import { n as er, b as T, o as tr, q as bt } from "./index-6e735f92.js";
class nr {
  constructor(e, n, r = !0, s) {
    this.automaticComponentRegistration = !0, this.registeredComponents = {}, this.propStateRegistrations = /* @__PURE__ */ new Map(), this.eventListenerRegistrations = /* @__PURE__ */ new Map(), this.host = e, this.stores = n, this.automaticComponentRegistration = r, this.eventOverrides = s, T(`[${this.hostTagName}] Initializing (abstract) provider.`, { eventOverrides: s }), this.registerComponent = this.registerComponent.bind(this), this.getStore = this.getStore.bind(this), Object.keys(this.stores).forEach((i) => {
      this.propStateRegistrations.set(i, /* @__PURE__ */ new Map());
    });
  }
  async componentWillLoad(e) {
    T(`[${this.hostTagName}] Will load`), this.setupStoreListeners(), this.nylasConnector = e;
    const n = Array.from(this.host.querySelectorAll("*")).filter((s) => s.tagName.toLowerCase().startsWith("nylas-"));
    T(`[${this.hostTagName}] Found ${n.length} child component(s).`, { childComponents: n });
    const r = n.map(async (s) => {
      const i = s;
      if (!i) {
        T(`[~${this.hostTagName}] (componentWillLoad) Component ${i.tagName} does not have a name. Skipping.`);
        return;
      }
      if (!i.registerNylasComponent) {
        T(`[~${this.hostTagName}] (componentWillLoad) Component ${i.tagName} is not a component that can be registered. Skipping.`, { component: i });
        return;
      }
      const o = {
        element: i,
        name: i.tagName.toLowerCase(),
        getStoresToProp: i.getStoresToProp,
        storeToProps: i.storeToProps,
        stateToProps: i.stateToProps,
        authToProp: i.authToProp,
        eventToProps: i.eventToProps,
        connectorToProp: i.connectorToProp,
        localPropsToProp: i.localPropsToProp
      };
      await this.registerComponent(o);
    });
    await Promise.all(r);
  }
  async componentDidLoad() {
    T(`[~${this.hostTagName}] (componentDidLoad) Did load`);
  }
  async componentDisconnected() {
    Object.values(this.stores).forEach((e) => {
      e.dispose();
    });
  }
  async registerComponentHandler(e) {
    if (e.stopPropagation(), !this.automaticComponentRegistration) {
      T(`~[${this.hostTagName}] (registerComponentHandler) Automatic component registration disabled. Skipping registration of ${e.detail.name}.`);
      return;
    }
    await this.registerComponent(e.detail);
  }
  async unregisterComponentHandler(e) {
    if (e.stopPropagation(), !this.automaticComponentRegistration) {
      T(`~[${this.hostTagName}] (unregisterComponentHandler) Automatic component registration disabled. Skipping unregistration of ${e.detail.name}.`);
      return;
    }
    this.unregisterComponent(e.detail);
  }
  async registerComponent(e) {
    T(`~[${this.hostTagName}] (registerComponent) Registering component ${e.name}.`);
    const n = e.element.dataset.nylasId;
    n && this.registeredComponents[n] ? (T(`[${this.hostTagName}] (registerComponent) Component ${e.name} already registered. Updating registration.`), this.cleanupComponentRegistration(n, !1)) : e.element.dataset.nylasId = n || tr();
    const s = e.element.dataset.nylasId;
    s && (this.registeredComponents[s] = e), T(`[${this.hostTagName}] (registerComponent) Waiting for "${e.element.localName}" component to be defined`, { component: e });
    try {
      await customElements.whenDefined(e.element.tagName.toLowerCase()), T(`[${this.hostTagName}] (registerComponent) Component "${e.element.localName}" is now defined`);
    } catch (p) {
      T(`[${this.hostTagName}] (registerComponent) Error waiting for component "${e.element.localName}" to be defined:`, p);
    }
    const i = this.eventOverrides, { stateToProps: o, getStoresToProp: u, eventToProps: a, storeToProps: c, connectorToProp: h, localPropsToProp: l, element: d } = e;
    a == null || a.forEach((p, m) => {
      var b;
      const f = this.nylasConnector, v = async (w) => {
        T(`[${this.hostTagName}] (registerComponent) Handling "${e.name}" prop "${String(m)}" event.`, { event: w }), m in i && (T(`[${this.hostTagName}] (registerComponent) Found event override for "${String(m)}" event. Calling override.`), await i[m](w, f)), w.defaultPrevented || await p(w, f);
      }, y = e.element.dataset.nylasId;
      y && !this.eventListenerRegistrations.has(y) && this.eventListenerRegistrations.set(y, []), y && ((b = this.eventListenerRegistrations.get(y)) == null || b.push([d, m, v])), T(`[${this.hostTagName}] (registerComponent) Setting "${e.name}" event "${String(m)}" to automcially call NylasConnector method.`);
      const g = bt(m.toString());
      T(`[${this.hostTagName}] (registerComponent) Adding event listener for "${g}" on "${d.tagName}"`), d.addEventListener(g, v);
    }), o == null || o.forEach((p, m) => {
      var b, w, C, k;
      const [f, v] = m.split("."), g = this.getStore(f).state[v];
      if (!d.dataset.nylasId) {
        T(`[${this.hostTagName}] (registerComponent) Component "${e.name}" not registered. Skipping.`, { component: e });
        return;
      }
      this.propStateRegistrations.has(f) || this.propStateRegistrations.set(f, /* @__PURE__ */ new Map()), (b = this.propStateRegistrations.get(f)) != null && b.has(v) ? (k = (C = this.propStateRegistrations.get(f)) == null ? void 0 : C.get(v)) == null || k.push({
        elementId: d.dataset.nylasId,
        propKey: p
      }) : (w = this.propStateRegistrations.get(f)) == null || w.set(v, [
        {
          elementId: d.dataset.nylasId,
          propKey: p
        }
      ]), d[p.toString()] = g, T(`[${this.hostTagName}] Setting "${e.name}" prop "${p.toString()}" to "${m}" value.`, { stateValue: g });
    }), l == null || l.forEach((p, m) => {
      const f = this.host[m];
      d[p.toString()] = f, T(`[${this.hostTagName}] Setting "${e.name}" prop "${p.toString()}" to the value of "${m}" value.`, { value: m, mappedPropValue: f });
    }), u && (d[u == null ? void 0 : u.toString()] = this.getStore, T(`[${this.hostTagName}] Setting "${e.name}" prop "${u.toString()}" to "getStore" method.`)), c == null || c.forEach((p, m) => {
      const f = this.getStore(m);
      d[p.toString()] = f, T(`[${this.hostTagName}] Setting "${e.name}" prop "${p.toString()}" to "${m}" store.`, { store: f });
    }), h && (d[h == null ? void 0 : h.toString()] = this.nylasConnector, T(`[${this.hostTagName}] Setting "${e.name}" prop "${h.toString()}" to "nylasConnector" value.`, { connectorToProp: h })), typeof d.registerCallback == "function" && (T(`[${this.hostTagName}] (registerComponent) Calling registerCallback method for "${e.name}".`), await d.registerCallback()), T(`[${this.hostTagName}] (registerComponent) Component ${e.name} registered.`);
  }
  cleanupComponentRegistration(e, n = !0) {
    const r = this.eventListenerRegistrations.get(e);
    r && (r.forEach(([s, i, o]) => {
      const u = bt(i.toString());
      T(`[${this.hostTagName}] (cleanupComponentRegistration) Removing event listener for "${u}" on "${s.tagName}"`), s.removeEventListener(u, o);
    }), this.eventListenerRegistrations.delete(e)), this.propStateRegistrations.forEach((s, i) => {
      s.forEach((o, u) => {
        var c;
        const a = o.filter((h) => h.elementId !== e);
        a.length !== o.length && ((c = this.propStateRegistrations.get(i)) == null || c.set(u, a));
      });
    }), n && delete this.registeredComponents[e];
  }
  unregisterComponent(e) {
    T(`[${this.hostTagName}] Unregistering component ${e.name}.`);
    const n = e.element.dataset.nylasId;
    if (!n) {
      T(`[${this.hostTagName}] (unregisterComponent) Unregistering component ${e.name}.`);
      return;
    }
    if (this.registeredComponents[n]) {
      T(`[${this.hostTagName}] (unregisterComponent) Component ${e.name} not registered. Skipping.`);
      return;
    }
    this.propStateRegistrations.forEach((s, i) => {
      s.forEach((o, u) => {
        var h, l;
        const a = (h = this.propStateRegistrations.get(i)) == null ? void 0 : h.get(u), c = a == null ? void 0 : a.filter((d) => d.elementId !== n);
        c && ((l = this.propStateRegistrations.get(i)) == null || l.set(u, c));
      });
    });
    const r = this.eventListenerRegistrations.get(n);
    r == null || r.forEach(([s, i, o]) => {
      const u = bt(i.toString());
      T(`[${this.hostTagName}] (unregisterComponent) Removing event listener for "${u}" on "${s.tagName}"`), s.removeEventListener(u, o);
    }), delete this.registeredComponents[n];
  }
  getStore(e) {
    const n = this.stores[e];
    if (!n)
      throw new Error(`[${this.hostTagName}] Store "${e.toString()}" not found.`);
    return n;
  }
  async setupStoreListeners() {
    const e = this;
    Object.entries(this.stores).forEach(([n, r]) => {
      T(`[${e.hostTagName}] (setupStoreListeners) Listening for changes in "${n}" store.`), r.use({
        set(s, i, o) {
          var c;
          if (T(`[${e.hostTagName}] (setupStoreListeners) Store "${n}" state "${s.toString()}" changed`, { newValue: i, oldValue: o }), i === o) {
            T(`[${e.hostTagName}] (setupStoreListeners) Store "${n}" state "${s.toString()}" unchanged. Skipping.`);
            return;
          }
          const u = e.registeredComponents;
          if (!u) {
            T(`[${e.hostTagName}] (setupStoreListeners) No registered components found. Skipping.`);
            return;
          }
          const a = ((c = e.propStateRegistrations.get(n)) == null ? void 0 : c.get(s.toString())) || [];
          T(`[${e.hostTagName}] (setupStoreListeners) Found ${a.length} prop(s) registered for "${s.toString()}" store.`, {
            props: a,
            propStateRegistrations: e.propStateRegistrations
          }), a.forEach(({ elementId: h, propKey: l }) => {
            const d = u[h];
            if (!d) {
              T(`[${e.hostTagName}] (setupStoreListeners) Component "${h}" not found. Skipping.`, { component: d });
              return;
            }
            const m = e.getStore(n).state[s];
            d.element[l.toString()] = m, T(`[${e.hostTagName}] (setupStoreListeners) Setting "${d.name}" prop "${l.toString()}" to "${s.toString()}" value.`, { stateValue: m });
          });
        }
      });
    });
  }
  get hostTagName() {
    var e, n;
    return ((n = (e = this.host) == null ? void 0 : e.tagName) == null ? void 0 : n.toLowerCase()) ?? "nylas-provider";
  }
}
class Xr extends nr {
}
var rr = /* @__PURE__ */ ((t) => (t.Error = "error", t.Warning = "warning", t.Info = "info", t.Success = "success", t))(rr || {});
const Qr = (t) => t !== null && typeof t == "object" && "error" in t, $ = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : er, I = Object.keys, M = Array.isArray;
function U(t, e) {
  return typeof e != "object" || I(e).forEach(function(n) {
    t[n] = e[n];
  }), t;
}
typeof Promise > "u" || $.Promise || ($.Promise = Promise);
const Be = Object.getPrototypeOf, sr = {}.hasOwnProperty;
function z(t, e) {
  return sr.call(t, e);
}
function Ce(t, e) {
  typeof e == "function" && (e = e(Be(t))), (typeof Reflect > "u" ? I : Reflect.ownKeys)(e).forEach((n) => {
    ee(t, n, e[n]);
  });
}
const xn = Object.defineProperty;
function ee(t, e, n, r) {
  xn(t, e, U(n && z(n, "get") && typeof n.get == "function" ? { get: n.get, set: n.set, configurable: !0 } : { value: n, configurable: !0, writable: !0 }, r));
}
function _e(t) {
  return { from: function(e) {
    return t.prototype = Object.create(e.prototype), ee(t.prototype, "constructor", t), { extend: Ce.bind(null, t.prototype) };
  } };
}
const ir = Object.getOwnPropertyDescriptor;
function Jt(t, e) {
  let n;
  return ir(t, e) || (n = Be(t)) && Jt(n, e);
}
const or = [].slice;
function ut(t, e, n) {
  return or.call(t, e, n);
}
function Sn(t, e) {
  return e(t);
}
function Ke(t) {
  if (!t)
    throw new Error("Assertion Failed");
}
function Cn(t) {
  $.setImmediate ? setImmediate(t) : setTimeout(t, 0);
}
function En(t, e) {
  return t.reduce((n, r, s) => {
    var i = e(r, s);
    return i && (n[i[0]] = i[1]), n;
  }, {});
}
function te(t, e) {
  if (z(t, e))
    return t[e];
  if (!e)
    return t;
  if (typeof e != "string") {
    for (var n = [], r = 0, s = e.length; r < s; ++r) {
      var i = te(t, e[r]);
      n.push(i);
    }
    return n;
  }
  var o = e.indexOf(".");
  if (o !== -1) {
    var u = t[e.substr(0, o)];
    return u === void 0 ? void 0 : te(u, e.substr(o + 1));
  }
}
function Y(t, e, n) {
  if (t && e !== void 0 && (!("isFrozen" in Object) || !Object.isFrozen(t)))
    if (typeof e != "string" && "length" in e) {
      Ke(typeof n != "string" && "length" in n);
      for (var r = 0, s = e.length; r < s; ++r)
        Y(t, e[r], n[r]);
    } else {
      var i = e.indexOf(".");
      if (i !== -1) {
        var o = e.substr(0, i), u = e.substr(i + 1);
        if (u === "")
          n === void 0 ? M(t) && !isNaN(parseInt(o)) ? t.splice(o, 1) : delete t[o] : t[o] = n;
        else {
          var a = t[o];
          a && z(t, o) || (a = t[o] = {}), Y(a, u, n);
        }
      } else
        n === void 0 ? M(t) && !isNaN(parseInt(e)) ? t.splice(e, 1) : delete t[e] : t[e] = n;
    }
}
function Pn(t) {
  var e = {};
  for (var n in t)
    z(t, n) && (e[n] = t[n]);
  return e;
}
const ar = [].concat;
function Tn(t) {
  return ar.apply([], t);
}
const On = "Boolean,String,Date,RegExp,Blob,File,FileList,FileSystemFileHandle,ArrayBuffer,DataView,Uint8ClampedArray,ImageBitmap,ImageData,Map,Set,CryptoKey".split(",").concat(Tn([8, 16, 32, 64].map((t) => ["Int", "Uint", "Float"].map((e) => e + t + "Array")))).filter((t) => $[t]), ur = On.map((t) => $[t]);
En(On, (t) => [t, !0]);
let se = null;
function Ve(t) {
  se = typeof WeakMap < "u" && /* @__PURE__ */ new WeakMap();
  const e = Pt(t);
  return se = null, e;
}
function Pt(t) {
  if (!t || typeof t != "object")
    return t;
  let e = se && se.get(t);
  if (e)
    return e;
  if (M(t)) {
    e = [], se && se.set(t, e);
    for (var n = 0, r = t.length; n < r; ++n)
      e.push(Pt(t[n]));
  } else if (ur.indexOf(t.constructor) >= 0)
    e = t;
  else {
    const i = Be(t);
    for (var s in e = i === Object.prototype ? {} : Object.create(i), se && se.set(t, e), t)
      z(t, s) && (e[s] = Pt(t[s]));
  }
  return e;
}
const { toString: lr } = {};
function Tt(t) {
  return lr.call(t).slice(8, -1);
}
const Ot = typeof Symbol < "u" ? Symbol.iterator : "@@iterator", cr = typeof Ot == "symbol" ? function(t) {
  var e;
  return t != null && (e = t[Ot]) && e.apply(t);
} : function() {
  return null;
}, we = {};
function J(t) {
  var e, n, r, s;
  if (arguments.length === 1) {
    if (M(t))
      return t.slice();
    if (this === we && typeof t == "string")
      return [t];
    if (s = cr(t)) {
      for (n = []; !(r = s.next()).done; )
        n.push(r.value);
      return n;
    }
    if (t == null)
      return [t];
    if (typeof (e = t.length) == "number") {
      for (n = new Array(e); e--; )
        n[e] = t[e];
      return n;
    }
    return [t];
  }
  for (e = arguments.length, n = new Array(e); e--; )
    n[e] = arguments[e];
  return n;
}
const Zt = typeof Symbol < "u" ? (t) => t[Symbol.toStringTag] === "AsyncFunction" : () => !1;
var G = typeof location < "u" && /^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);
function An(t, e) {
  G = t, Kn = e;
}
var Kn = () => !0;
const hr = !new Error("").stack;
function Ee() {
  if (hr)
    try {
      throw new Error();
    } catch (t) {
      return t;
    }
  return new Error();
}
function At(t, e) {
  var n = t.stack;
  return n ? (e = e || 0, n.indexOf(t.name) === 0 && (e += (t.name + t.message).split(`
`).length), n.split(`
`).slice(e).filter(Kn).map((r) => `
` + r).join("")) : "";
}
var $n = ["Unknown", "Constraint", "Data", "TransactionInactive", "ReadOnly", "Version", "NotFound", "InvalidState", "InvalidAccess", "Abort", "Timeout", "QuotaExceeded", "Syntax", "DataClone"], en = ["Modify", "Bulk", "OpenFailed", "VersionChange", "Schema", "Upgrade", "InvalidTable", "MissingAPI", "NoSuchDatabase", "InvalidArgument", "SubTransaction", "Unsupported", "Internal", "DatabaseClosed", "PrematureCommit", "ForeignAwait"].concat($n), dr = { VersionChanged: "Database version changed by other database connection", DatabaseClosed: "Database has been closed", Abort: "Transaction aborted", TransactionInactive: "Transaction has already completed or failed", MissingAPI: "IndexedDB API missing. Please visit https://tinyurl.com/y2uuvskb" };
function ke(t, e) {
  this._e = Ee(), this.name = t, this.message = e;
}
function Nn(t, e) {
  return t + ". Errors: " + Object.keys(e).map((n) => e[n].toString()).filter((n, r, s) => s.indexOf(n) === r).join(`
`);
}
function lt(t, e, n, r) {
  this._e = Ee(), this.failures = e, this.failedKeys = r, this.successCount = n, this.message = Nn(t, e);
}
function Ne(t, e) {
  this._e = Ee(), this.name = "BulkError", this.failures = Object.keys(e).map((n) => e[n]), this.failuresByPos = e, this.message = Nn(t, e);
}
_e(ke).from(Error).extend({ stack: { get: function() {
  return this._stack || (this._stack = this.name + ": " + this.message + At(this._e, 2));
} }, toString: function() {
  return this.name + ": " + this.message;
} }), _e(lt).from(ke), _e(Ne).from(ke);
var tn = en.reduce((t, e) => (t[e] = e + "Error", t), {});
const fr = ke;
var P = en.reduce((t, e) => {
  var n = e + "Error";
  function r(s, i) {
    this._e = Ee(), this.name = n, s ? typeof s == "string" ? (this.message = `${s}${i ? `
 ` + i : ""}`, this.inner = i || null) : typeof s == "object" && (this.message = `${s.name} ${s.message}`, this.inner = s) : (this.message = dr[e] || n, this.inner = null);
  }
  return _e(r).from(fr), t[e] = r, t;
}, {});
P.Syntax = SyntaxError, P.Type = TypeError, P.Range = RangeError;
var hn = $n.reduce((t, e) => (t[e + "Error"] = P[e], t), {}), tt = en.reduce((t, e) => (["Syntax", "Type", "Range"].indexOf(e) === -1 && (t[e + "Error"] = P[e]), t), {});
function K() {
}
function Fe(t) {
  return t;
}
function pr(t, e) {
  return t == null || t === Fe ? e : function(n) {
    return e(t(n));
  };
}
function pe(t, e) {
  return function() {
    t.apply(this, arguments), e.apply(this, arguments);
  };
}
function mr(t, e) {
  return t === K ? e : function() {
    var n = t.apply(this, arguments);
    n !== void 0 && (arguments[0] = n);
    var r = this.onsuccess, s = this.onerror;
    this.onsuccess = null, this.onerror = null;
    var i = e.apply(this, arguments);
    return r && (this.onsuccess = this.onsuccess ? pe(r, this.onsuccess) : r), s && (this.onerror = this.onerror ? pe(s, this.onerror) : s), i !== void 0 ? i : n;
  };
}
function gr(t, e) {
  return t === K ? e : function() {
    t.apply(this, arguments);
    var n = this.onsuccess, r = this.onerror;
    this.onsuccess = this.onerror = null, e.apply(this, arguments), n && (this.onsuccess = this.onsuccess ? pe(n, this.onsuccess) : n), r && (this.onerror = this.onerror ? pe(r, this.onerror) : r);
  };
}
function yr(t, e) {
  return t === K ? e : function(n) {
    var r = t.apply(this, arguments);
    U(n, r);
    var s = this.onsuccess, i = this.onerror;
    this.onsuccess = null, this.onerror = null;
    var o = e.apply(this, arguments);
    return s && (this.onsuccess = this.onsuccess ? pe(s, this.onsuccess) : s), i && (this.onerror = this.onerror ? pe(i, this.onerror) : i), r === void 0 ? o === void 0 ? void 0 : o : U(r, o);
  };
}
function vr(t, e) {
  return t === K ? e : function() {
    return e.apply(this, arguments) !== !1 && t.apply(this, arguments);
  };
}
function nn(t, e) {
  return t === K ? e : function() {
    var n = t.apply(this, arguments);
    if (n && typeof n.then == "function") {
      for (var r = this, s = arguments.length, i = new Array(s); s--; )
        i[s] = arguments[s];
      return n.then(function() {
        return e.apply(r, i);
      });
    }
    return e.apply(this, arguments);
  };
}
tt.ModifyError = lt, tt.DexieError = ke, tt.BulkError = Ne;
var Me = {};
const Rn = 100, [Kt, ct, $t] = typeof Promise > "u" ? [] : (() => {
  let t = Promise.resolve();
  if (typeof crypto > "u" || !crypto.subtle)
    return [t, Be(t), t];
  const e = crypto.subtle.digest("SHA-512", new Uint8Array([0]));
  return [e, Be(e), t];
})(), jn = ct && ct.then, nt = Kt && Kt.constructor, rn = !!$t;
var Nt = !1, br = $t ? () => {
  $t.then(He);
} : $.setImmediate ? setImmediate.bind(null, He) : $.MutationObserver ? () => {
  var t = document.createElement("div");
  new MutationObserver(() => {
    He(), t = null;
  }).observe(t, { attributes: !0 }), t.setAttribute("i", "1");
} : () => {
  setTimeout(He, 0);
}, Re = function(t, e) {
  $e.push([t, e]), ht && (br(), ht = !1);
}, Rt = !0, ht = !0, de = [], rt = [], jt = null, It = Fe, xe = { id: "global", global: !0, ref: 0, unhandleds: [], onunhandled: pn, pgp: !1, env: {}, finalize: function() {
  this.unhandleds.forEach((t) => {
    try {
      pn(t[0], t[1]);
    } catch {
    }
  });
} }, E = xe, $e = [], fe = 0, st = [];
function S(t) {
  if (typeof this != "object")
    throw new TypeError("Promises must be constructed via new");
  this._listeners = [], this.onuncatched = K, this._lib = !1;
  var e = this._PSD = E;
  if (G && (this._stackHolder = Ee(), this._prev = null, this._numPrev = 0), typeof t != "function") {
    if (t !== Me)
      throw new TypeError("Not a function");
    return this._state = arguments[1], this._value = arguments[2], void (this._state === !1 && Bt(this, this._value));
  }
  this._state = null, this._value = null, ++e.ref, Dn(this, t);
}
const Dt = { get: function() {
  var t = E, e = dt;
  function n(r, s) {
    var i = !t.global && (t !== E || e !== dt);
    const o = i && !ne();
    var u = new S((a, c) => {
      sn(this, new In(ft(r, t, i, o), ft(s, t, i, o), a, c, t));
    });
    return G && Mn(u, this), u;
  }
  return n.prototype = Me, n;
}, set: function(t) {
  ee(this, "then", t && t.prototype === Me ? Dt : { get: function() {
    return t;
  }, set: Dt.set });
} };
function In(t, e, n, r, s) {
  this.onFulfilled = typeof t == "function" ? t : null, this.onRejected = typeof e == "function" ? e : null, this.resolve = n, this.reject = r, this.psd = s;
}
function Dn(t, e) {
  try {
    e((n) => {
      if (t._state === null) {
        if (n === t)
          throw new TypeError("A promise cannot be resolved with itself.");
        var r = t._lib && ze();
        n && typeof n.then == "function" ? Dn(t, (s, i) => {
          n instanceof S ? n._then(s, i) : n.then(s, i);
        }) : (t._state = !0, t._value = n, Bn(t)), r && Ye();
      }
    }, Bt.bind(null, t));
  } catch (n) {
    Bt(t, n);
  }
}
function Bt(t, e) {
  if (rt.push(e), t._state === null) {
    var n = t._lib && ze();
    e = It(e), t._state = !1, t._value = e, G && e !== null && typeof e == "object" && !e._promise && function(r, s, i) {
      try {
        r.apply(null, i);
      } catch (o) {
        s && s(o);
      }
    }(() => {
      var r = Jt(e, "stack");
      e._promise = t, ee(e, "stack", { get: () => Nt ? r && (r.get ? r.get.apply(e) : r.value) : t.stack });
    }), function(r) {
      de.some((s) => s._value === r._value) || de.push(r);
    }(t), Bn(t), n && Ye();
  }
}
function Bn(t) {
  var e = t._listeners;
  t._listeners = [];
  for (var n = 0, r = e.length; n < r; ++n)
    sn(t, e[n]);
  var s = t._PSD;
  --s.ref || s.finalize(), fe === 0 && (++fe, Re(() => {
    --fe == 0 && on();
  }, []));
}
function sn(t, e) {
  if (t._state !== null) {
    var n = t._state ? e.onFulfilled : e.onRejected;
    if (n === null)
      return (t._state ? e.resolve : e.reject)(t._value);
    ++e.psd.ref, ++fe, Re(wr, [n, t, e]);
  } else
    t._listeners.push(e);
}
function wr(t, e, n) {
  try {
    jt = e;
    var r, s = e._value;
    e._state ? r = t(s) : (rt.length && (rt = []), r = t(s), rt.indexOf(s) === -1 && function(i) {
      for (var o = de.length; o; )
        if (de[--o]._value === i._value)
          return void de.splice(o, 1);
    }(e)), n.resolve(r);
  } catch (i) {
    n.reject(i);
  } finally {
    jt = null, --fe == 0 && on(), --n.psd.ref || n.psd.finalize();
  }
}
function Fn(t, e, n) {
  if (e.length === n)
    return e;
  var r = "";
  if (t._state === !1) {
    var s, i, o = t._value;
    o != null ? (s = o.name || "Error", i = o.message || o, r = At(o, 0)) : (s = o, i = ""), e.push(s + (i ? ": " + i : "") + r);
  }
  return G && ((r = At(t._stackHolder, 2)) && e.indexOf(r) === -1 && e.push(r), t._prev && Fn(t._prev, e, n)), e;
}
function Mn(t, e) {
  var n = e ? e._numPrev + 1 : 0;
  n < 100 && (t._prev = e, t._numPrev = n);
}
function He() {
  ze() && Ye();
}
function ze() {
  var t = Rt;
  return Rt = !1, ht = !1, t;
}
function Ye() {
  var t, e, n;
  do
    for (; $e.length > 0; )
      for (t = $e, $e = [], n = t.length, e = 0; e < n; ++e) {
        var r = t[e];
        r[0].apply(null, r[1]);
      }
  while ($e.length > 0);
  Rt = !0, ht = !0;
}
function on() {
  var t = de;
  de = [], t.forEach((r) => {
    r._PSD.onunhandled.call(null, r._value, r);
  });
  for (var e = st.slice(0), n = e.length; n; )
    e[--n]();
}
function Ge(t) {
  return new S(Me, !1, t);
}
function N(t, e) {
  var n = E;
  return function() {
    var r = ze(), s = E;
    try {
      return ae(n, !0), t.apply(this, arguments);
    } catch (i) {
      e && e(i);
    } finally {
      ae(s, !1), r && Ye();
    }
  };
}
Ce(S.prototype, { then: Dt, _then: function(t, e) {
  sn(this, new In(null, null, t, e, E));
}, catch: function(t) {
  if (arguments.length === 1)
    return this.then(null, t);
  var e = arguments[0], n = arguments[1];
  return typeof e == "function" ? this.then(null, (r) => r instanceof e ? n(r) : Ge(r)) : this.then(null, (r) => r && r.name === e ? n(r) : Ge(r));
}, finally: function(t) {
  return this.then((e) => (t(), e), (e) => (t(), Ge(e)));
}, stack: { get: function() {
  if (this._stack)
    return this._stack;
  try {
    Nt = !0;
    var t = Fn(this, [], 20).join(`
From previous: `);
    return this._state !== null && (this._stack = t), t;
  } finally {
    Nt = !1;
  }
} }, timeout: function(t, e) {
  return t < 1 / 0 ? new S((n, r) => {
    var s = setTimeout(() => r(new P.Timeout(e)), t);
    this.then(n, r).finally(clearTimeout.bind(null, s));
  }) : this;
} }), typeof Symbol < "u" && Symbol.toStringTag && ee(S.prototype, Symbol.toStringTag, "Dexie.Promise"), xe.env = qn(), Ce(S, { all: function() {
  var t = J.apply(null, arguments).map(Xe);
  return new S(function(e, n) {
    t.length === 0 && e([]);
    var r = t.length;
    t.forEach((s, i) => S.resolve(s).then((o) => {
      t[i] = o, --r || e(t);
    }, n));
  });
}, resolve: (t) => {
  if (t instanceof S)
    return t;
  if (t && typeof t.then == "function")
    return new S((n, r) => {
      t.then(n, r);
    });
  var e = new S(Me, !0, t);
  return Mn(e, jt), e;
}, reject: Ge, race: function() {
  var t = J.apply(null, arguments).map(Xe);
  return new S((e, n) => {
    t.map((r) => S.resolve(r).then(e, n));
  });
}, PSD: { get: () => E, set: (t) => E = t }, totalEchoes: { get: () => dt }, newPSD: oe, usePSD: Te, scheduler: { get: () => Re, set: (t) => {
  Re = t;
} }, rejectionMapper: { get: () => It, set: (t) => {
  It = t;
} }, follow: (t, e) => new S((n, r) => oe((s, i) => {
  var o = E;
  o.unhandleds = [], o.onunhandled = i, o.finalize = pe(function() {
    (function(u) {
      function a() {
        u(), st.splice(st.indexOf(a), 1);
      }
      st.push(a), ++fe, Re(() => {
        --fe == 0 && on();
      }, []);
    })(() => {
      this.unhandleds.length === 0 ? s() : i(this.unhandleds[0]);
    });
  }, o.finalize), t();
}, e, n, r)) }), nt && (nt.allSettled && ee(S, "allSettled", function() {
  const t = J.apply(null, arguments).map(Xe);
  return new S((e) => {
    t.length === 0 && e([]);
    let n = t.length;
    const r = new Array(n);
    t.forEach((s, i) => S.resolve(s).then((o) => r[i] = { status: "fulfilled", value: o }, (o) => r[i] = { status: "rejected", reason: o }).then(() => --n || e(r)));
  });
}), nt.any && typeof AggregateError < "u" && ee(S, "any", function() {
  const t = J.apply(null, arguments).map(Xe);
  return new S((e, n) => {
    t.length === 0 && n(new AggregateError([]));
    let r = t.length;
    const s = new Array(r);
    t.forEach((i, o) => S.resolve(i).then((u) => e(u), (u) => {
      s[o] = u, --r || n(new AggregateError(s));
    }));
  });
}));
const F = { awaits: 0, echoes: 0, id: 0 };
var _r = 0, it = [], wt = 0, dt = 0, kr = 0;
function oe(t, e, n, r) {
  var s = E, i = Object.create(s);
  i.parent = s, i.ref = 0, i.global = !1, i.id = ++kr;
  var o = xe.env;
  i.env = rn ? { Promise: S, PromiseProp: { value: S, configurable: !0, writable: !0 }, all: S.all, race: S.race, allSettled: S.allSettled, any: S.any, resolve: S.resolve, reject: S.reject, nthen: dn(o.nthen, i), gthen: dn(o.gthen, i) } : {}, e && U(i, e), ++s.ref, i.finalize = function() {
    --this.parent.ref || this.parent.finalize();
  };
  var u = Te(i, t, n, r);
  return i.ref === 0 && i.finalize(), u;
}
function Pe() {
  return F.id || (F.id = ++_r), ++F.awaits, F.echoes += Rn, F.id;
}
function ne() {
  return !!F.awaits && (--F.awaits == 0 && (F.id = 0), F.echoes = F.awaits * Rn, !0);
}
function Xe(t) {
  return F.echoes && t && t.constructor === nt ? (Pe(), t.then((e) => (ne(), e), (e) => (ne(), D(e)))) : t;
}
function xr(t) {
  ++dt, F.echoes && --F.echoes != 0 || (F.echoes = F.id = 0), it.push(E), ae(t, !0);
}
function Sr() {
  var t = it[it.length - 1];
  it.pop(), ae(t, !1);
}
function ae(t, e) {
  var n = E;
  if ((e ? !F.echoes || wt++ && t === E : !wt || --wt && t === E) || Ln(e ? xr.bind(null, t) : Sr), t !== E && (E = t, n === xe && (xe.env = qn()), rn)) {
    var r = xe.env.Promise, s = t.env;
    ct.then = s.nthen, r.prototype.then = s.gthen, (n.global || t.global) && (Object.defineProperty($, "Promise", s.PromiseProp), r.all = s.all, r.race = s.race, r.resolve = s.resolve, r.reject = s.reject, s.allSettled && (r.allSettled = s.allSettled), s.any && (r.any = s.any));
  }
}
function qn() {
  var t = $.Promise;
  return rn ? { Promise: t, PromiseProp: Object.getOwnPropertyDescriptor($, "Promise"), all: t.all, race: t.race, allSettled: t.allSettled, any: t.any, resolve: t.resolve, reject: t.reject, nthen: ct.then, gthen: t.prototype.then } : {};
}
function Te(t, e, n, r, s) {
  var i = E;
  try {
    return ae(t, !0), e(n, r, s);
  } finally {
    ae(i, !1);
  }
}
function Ln(t) {
  jn.call(Kt, t);
}
function ft(t, e, n, r) {
  return typeof t != "function" ? t : function() {
    var s = E;
    n && Pe(), ae(e, !0);
    try {
      return t.apply(this, arguments);
    } finally {
      ae(s, !1), r && Ln(ne);
    }
  };
}
function dn(t, e) {
  return function(n, r) {
    return t.call(this, ft(n, e), ft(r, e));
  };
}
("" + jn).indexOf("[native code]") === -1 && (Pe = ne = K);
const fn = "unhandledrejection";
function pn(t, e) {
  var n;
  try {
    n = e.onuncatched(t);
  } catch {
  }
  if (n !== !1)
    try {
      var r, s = { promise: e, reason: t };
      if ($.document && document.createEvent ? ((r = document.createEvent("Event")).initEvent(fn, !0, !0), U(r, s)) : $.CustomEvent && U(r = new CustomEvent(fn, { detail: s }), s), r && $.dispatchEvent && (dispatchEvent(r), !$.PromiseRejectionEvent && $.onunhandledrejection))
        try {
          $.onunhandledrejection(r);
        } catch {
        }
      G && r && !r.defaultPrevented && console.warn(`Unhandled rejection: ${t.stack || t}`);
    } catch {
    }
}
var D = S.reject;
function Ft(t, e, n, r) {
  if (t.idbdb && (t._state.openComplete || E.letThrough || t._vip)) {
    var s = t._createTransaction(e, n, t._dbSchema);
    try {
      s.create(), t._state.PR1398_maxLoop = 3;
    } catch (i) {
      return i.name === tn.InvalidState && t.isOpen() && --t._state.PR1398_maxLoop > 0 ? (console.warn("Dexie: Need to reopen db"), t._close(), t.open().then(() => Ft(t, e, n, r))) : D(i);
    }
    return s._promise(e, (i, o) => oe(() => (E.trans = s, r(i, o, s)))).then((i) => s._completion.then(() => i));
  }
  if (t._state.openComplete)
    return D(new P.DatabaseClosed(t._state.dbOpenError));
  if (!t._state.isBeingOpened) {
    if (!t._options.autoOpen)
      return D(new P.DatabaseClosed());
    t.open().catch(K);
  }
  return t._state.dbReadyPromise.then(() => Ft(t, e, n, r));
}
const mn = "3.2.4", he = String.fromCharCode(65535), Mt = -1 / 0, X = "Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.", Un = "String expected.", je = [], gt = typeof navigator < "u" && /(MSIE|Trident|Edge)/.test(navigator.userAgent), Cr = gt, Er = gt, Wn = (t) => !/(dexie\.js|dexie\.min\.js)/.test(t), yt = "__dbnames", _t = "readonly", kt = "readwrite";
function me(t, e) {
  return t ? e ? function() {
    return t.apply(this, arguments) && e.apply(this, arguments);
  } : t : e;
}
const Vn = { type: 3, lower: -1 / 0, lowerOpen: !1, upper: [[]], upperOpen: !1 };
function Qe(t) {
  return typeof t != "string" || /\./.test(t) ? (e) => e : (e) => (e[t] === void 0 && t in e && delete (e = Ve(e))[t], e);
}
class Pr {
  _trans(e, n, r) {
    const s = this._tx || E.trans, i = this.name;
    function o(a, c, h) {
      if (!h.schema[i])
        throw new P.NotFound("Table " + i + " not part of transaction");
      return n(h.idbtrans, h);
    }
    const u = ze();
    try {
      return s && s.db === this.db ? s === E.trans ? s._promise(e, o, r) : oe(() => s._promise(e, o, r), { trans: s, transless: E.transless || E }) : Ft(this.db, e, [this.name], o);
    } finally {
      u && Ye();
    }
  }
  get(e, n) {
    return e && e.constructor === Object ? this.where(e).first(n) : this._trans("readonly", (r) => this.core.get({ trans: r, key: e }).then((s) => this.hook.reading.fire(s))).then(n);
  }
  where(e) {
    if (typeof e == "string")
      return new this.db.WhereClause(this, e);
    if (M(e))
      return new this.db.WhereClause(this, `[${e.join("+")}]`);
    const n = I(e);
    if (n.length === 1)
      return this.where(n[0]).equals(e[n[0]]);
    const r = this.schema.indexes.concat(this.schema.primKey).filter((c) => c.compound && n.every((h) => c.keyPath.indexOf(h) >= 0) && c.keyPath.every((h) => n.indexOf(h) >= 0))[0];
    if (r && this.db._maxKey !== he)
      return this.where(r.name).equals(r.keyPath.map((c) => e[c]));
    !r && G && console.warn(`The query ${JSON.stringify(e)} on ${this.name} would benefit of a compound index [${n.join("+")}]`);
    const { idxByName: s } = this.schema, i = this.db._deps.indexedDB;
    function o(c, h) {
      try {
        return i.cmp(c, h) === 0;
      } catch {
        return !1;
      }
    }
    const [u, a] = n.reduce(([c, h], l) => {
      const d = s[l], p = e[l];
      return [c || d, c || !d ? me(h, d && d.multi ? (m) => {
        const f = te(m, l);
        return M(f) && f.some((v) => o(p, v));
      } : (m) => o(p, te(m, l))) : h];
    }, [null, null]);
    return u ? this.where(u.name).equals(e[u.keyPath]).filter(a) : r ? this.filter(a) : this.where(n).equals("");
  }
  filter(e) {
    return this.toCollection().and(e);
  }
  count(e) {
    return this.toCollection().count(e);
  }
  offset(e) {
    return this.toCollection().offset(e);
  }
  limit(e) {
    return this.toCollection().limit(e);
  }
  each(e) {
    return this.toCollection().each(e);
  }
  toArray(e) {
    return this.toCollection().toArray(e);
  }
  toCollection() {
    return new this.db.Collection(new this.db.WhereClause(this));
  }
  orderBy(e) {
    return new this.db.Collection(new this.db.WhereClause(this, M(e) ? `[${e.join("+")}]` : e));
  }
  reverse() {
    return this.toCollection().reverse();
  }
  mapToClass(e) {
    this.schema.mappedClass = e;
    const n = (r) => {
      if (!r)
        return r;
      const s = Object.create(e.prototype);
      for (var i in r)
        if (z(r, i))
          try {
            s[i] = r[i];
          } catch {
          }
      return s;
    };
    return this.schema.readHook && this.hook.reading.unsubscribe(this.schema.readHook), this.schema.readHook = n, this.hook("reading", n), e;
  }
  defineClass() {
    return this.mapToClass(function(e) {
      U(this, e);
    });
  }
  add(e, n) {
    const { auto: r, keyPath: s } = this.schema.primKey;
    let i = e;
    return s && r && (i = Qe(s)(e)), this._trans("readwrite", (o) => this.core.mutate({ trans: o, type: "add", keys: n != null ? [n] : null, values: [i] })).then((o) => o.numFailures ? S.reject(o.failures[0]) : o.lastResult).then((o) => {
      if (s)
        try {
          Y(e, s, o);
        } catch {
        }
      return o;
    });
  }
  update(e, n) {
    if (typeof e != "object" || M(e))
      return this.where(":id").equals(e).modify(n);
    {
      const r = te(e, this.schema.primKey.keyPath);
      if (r === void 0)
        return D(new P.InvalidArgument("Given object does not contain its primary key"));
      try {
        typeof n != "function" ? I(n).forEach((s) => {
          Y(e, s, n[s]);
        }) : n(e, { value: e, primKey: r });
      } catch {
      }
      return this.where(":id").equals(r).modify(n);
    }
  }
  put(e, n) {
    const { auto: r, keyPath: s } = this.schema.primKey;
    let i = e;
    return s && r && (i = Qe(s)(e)), this._trans("readwrite", (o) => this.core.mutate({ trans: o, type: "put", values: [i], keys: n != null ? [n] : null })).then((o) => o.numFailures ? S.reject(o.failures[0]) : o.lastResult).then((o) => {
      if (s)
        try {
          Y(e, s, o);
        } catch {
        }
      return o;
    });
  }
  delete(e) {
    return this._trans("readwrite", (n) => this.core.mutate({ trans: n, type: "delete", keys: [e] })).then((n) => n.numFailures ? S.reject(n.failures[0]) : void 0);
  }
  clear() {
    return this._trans("readwrite", (e) => this.core.mutate({ trans: e, type: "deleteRange", range: Vn })).then((e) => e.numFailures ? S.reject(e.failures[0]) : void 0);
  }
  bulkGet(e) {
    return this._trans("readonly", (n) => this.core.getMany({ keys: e, trans: n }).then((r) => r.map((s) => this.hook.reading.fire(s))));
  }
  bulkAdd(e, n, r) {
    const s = Array.isArray(n) ? n : void 0, i = (r = r || (s ? void 0 : n)) ? r.allKeys : void 0;
    return this._trans("readwrite", (o) => {
      const { auto: u, keyPath: a } = this.schema.primKey;
      if (a && s)
        throw new P.InvalidArgument("bulkAdd(): keys argument invalid on tables with inbound keys");
      if (s && s.length !== e.length)
        throw new P.InvalidArgument("Arguments objects and keys must have the same length");
      const c = e.length;
      let h = a && u ? e.map(Qe(a)) : e;
      return this.core.mutate({ trans: o, type: "add", keys: s, values: h, wantResults: i }).then(({ numFailures: l, results: d, lastResult: p, failures: m }) => {
        if (l === 0)
          return i ? d : p;
        throw new Ne(`${this.name}.bulkAdd(): ${l} of ${c} operations failed`, m);
      });
    });
  }
  bulkPut(e, n, r) {
    const s = Array.isArray(n) ? n : void 0, i = (r = r || (s ? void 0 : n)) ? r.allKeys : void 0;
    return this._trans("readwrite", (o) => {
      const { auto: u, keyPath: a } = this.schema.primKey;
      if (a && s)
        throw new P.InvalidArgument("bulkPut(): keys argument invalid on tables with inbound keys");
      if (s && s.length !== e.length)
        throw new P.InvalidArgument("Arguments objects and keys must have the same length");
      const c = e.length;
      let h = a && u ? e.map(Qe(a)) : e;
      return this.core.mutate({ trans: o, type: "put", keys: s, values: h, wantResults: i }).then(({ numFailures: l, results: d, lastResult: p, failures: m }) => {
        if (l === 0)
          return i ? d : p;
        throw new Ne(`${this.name}.bulkPut(): ${l} of ${c} operations failed`, m);
      });
    });
  }
  bulkDelete(e) {
    const n = e.length;
    return this._trans("readwrite", (r) => this.core.mutate({ trans: r, type: "delete", keys: e })).then(({ numFailures: r, lastResult: s, failures: i }) => {
      if (r === 0)
        return s;
      throw new Ne(`${this.name}.bulkDelete(): ${r} of ${n} operations failed`, i);
    });
  }
}
function Ie(t) {
  var e = {}, n = function(o, u) {
    if (u) {
      for (var a = arguments.length, c = new Array(a - 1); --a; )
        c[a - 1] = arguments[a];
      return e[o].subscribe.apply(null, c), t;
    }
    if (typeof o == "string")
      return e[o];
  };
  n.addEventType = i;
  for (var r = 1, s = arguments.length; r < s; ++r)
    i(arguments[r]);
  return n;
  function i(o, u, a) {
    if (typeof o != "object") {
      var c;
      u || (u = vr), a || (a = K);
      var h = { subscribers: [], fire: a, subscribe: function(l) {
        h.subscribers.indexOf(l) === -1 && (h.subscribers.push(l), h.fire = u(h.fire, l));
      }, unsubscribe: function(l) {
        h.subscribers = h.subscribers.filter(function(d) {
          return d !== l;
        }), h.fire = h.subscribers.reduce(u, a);
      } };
      return e[o] = n[o] = h, h;
    }
    I(c = o).forEach(function(l) {
      var d = c[l];
      if (M(d))
        i(l, c[l][0], c[l][1]);
      else {
        if (d !== "asap")
          throw new P.InvalidArgument("Invalid event config");
        var p = i(l, Fe, function() {
          for (var m = arguments.length, f = new Array(m); m--; )
            f[m] = arguments[m];
          p.subscribers.forEach(function(v) {
            Cn(function() {
              v.apply(null, f);
            });
          });
        });
      }
    });
  }
}
function Ae(t, e) {
  return _e(e).from({ prototype: t }), e;
}
function ve(t, e) {
  return !(t.filter || t.algorithm || t.or) && (e ? t.justLimit : !t.replayFilter);
}
function xt(t, e) {
  t.filter = me(t.filter, e);
}
function St(t, e, n) {
  var r = t.replayFilter;
  t.replayFilter = r ? () => me(r(), e()) : e, t.justLimit = n && !r;
}
function ot(t, e) {
  if (t.isPrimKey)
    return e.primaryKey;
  const n = e.getIndexByKeyPath(t.index);
  if (!n)
    throw new P.Schema("KeyPath " + t.index + " on object store " + e.name + " is not indexed");
  return n;
}
function gn(t, e, n) {
  const r = ot(t, e.schema);
  return e.openCursor({ trans: n, values: !t.keysOnly, reverse: t.dir === "prev", unique: !!t.unique, query: { index: r, range: t.range } });
}
function Je(t, e, n, r) {
  const s = t.replayFilter ? me(t.filter, t.replayFilter()) : t.filter;
  if (t.or) {
    const i = {}, o = (u, a, c) => {
      if (!s || s(a, c, (d) => a.stop(d), (d) => a.fail(d))) {
        var h = a.primaryKey, l = "" + h;
        l === "[object ArrayBuffer]" && (l = "" + new Uint8Array(h)), z(i, l) || (i[l] = !0, e(u, a, c));
      }
    };
    return Promise.all([t.or._iterate(o, n), yn(gn(t, r, n), t.algorithm, o, !t.keysOnly && t.valueMapper)]);
  }
  return yn(gn(t, r, n), me(t.algorithm, s), e, !t.keysOnly && t.valueMapper);
}
function yn(t, e, n, r) {
  var s = N(r ? (i, o, u) => n(r(i), o, u) : n);
  return t.then((i) => {
    if (i)
      return i.start(() => {
        var o = () => i.continue();
        e && !e(i, (u) => o = u, (u) => {
          i.stop(u), o = K;
        }, (u) => {
          i.fail(u), o = K;
        }) || s(i.value, i, (u) => o = u), o();
      });
  });
}
function L(t, e) {
  try {
    const n = vn(t), r = vn(e);
    if (n !== r)
      return n === "Array" ? 1 : r === "Array" ? -1 : n === "binary" ? 1 : r === "binary" ? -1 : n === "string" ? 1 : r === "string" ? -1 : n === "Date" ? 1 : r !== "Date" ? NaN : -1;
    switch (n) {
      case "number":
      case "Date":
      case "string":
        return t > e ? 1 : t < e ? -1 : 0;
      case "binary":
        return function(s, i) {
          const o = s.length, u = i.length, a = o < u ? o : u;
          for (let c = 0; c < a; ++c)
            if (s[c] !== i[c])
              return s[c] < i[c] ? -1 : 1;
          return o === u ? 0 : o < u ? -1 : 1;
        }(bn(t), bn(e));
      case "Array":
        return function(s, i) {
          const o = s.length, u = i.length, a = o < u ? o : u;
          for (let c = 0; c < a; ++c) {
            const h = L(s[c], i[c]);
            if (h !== 0)
              return h;
          }
          return o === u ? 0 : o < u ? -1 : 1;
        }(t, e);
    }
  } catch {
  }
  return NaN;
}
function vn(t) {
  const e = typeof t;
  if (e !== "object")
    return e;
  if (ArrayBuffer.isView(t))
    return "binary";
  const n = Tt(t);
  return n === "ArrayBuffer" ? "binary" : n;
}
function bn(t) {
  return t instanceof Uint8Array ? t : ArrayBuffer.isView(t) ? new Uint8Array(t.buffer, t.byteOffset, t.byteLength) : new Uint8Array(t);
}
class Tr {
  _read(e, n) {
    var r = this._ctx;
    return r.error ? r.table._trans(null, D.bind(null, r.error)) : r.table._trans("readonly", e).then(n);
  }
  _write(e) {
    var n = this._ctx;
    return n.error ? n.table._trans(null, D.bind(null, n.error)) : n.table._trans("readwrite", e, "locked");
  }
  _addAlgorithm(e) {
    var n = this._ctx;
    n.algorithm = me(n.algorithm, e);
  }
  _iterate(e, n) {
    return Je(this._ctx, e, n, this._ctx.table.core);
  }
  clone(e) {
    var n = Object.create(this.constructor.prototype), r = Object.create(this._ctx);
    return e && U(r, e), n._ctx = r, n;
  }
  raw() {
    return this._ctx.valueMapper = null, this;
  }
  each(e) {
    var n = this._ctx;
    return this._read((r) => Je(n, e, r, n.table.core));
  }
  count(e) {
    return this._read((n) => {
      const r = this._ctx, s = r.table.core;
      if (ve(r, !0))
        return s.count({ trans: n, query: { index: ot(r, s.schema), range: r.range } }).then((o) => Math.min(o, r.limit));
      var i = 0;
      return Je(r, () => (++i, !1), n, s).then(() => i);
    }).then(e);
  }
  sortBy(e, n) {
    const r = e.split(".").reverse(), s = r[0], i = r.length - 1;
    function o(c, h) {
      return h ? o(c[r[h]], h - 1) : c[s];
    }
    var u = this._ctx.dir === "next" ? 1 : -1;
    function a(c, h) {
      var l = o(c, i), d = o(h, i);
      return l < d ? -u : l > d ? u : 0;
    }
    return this.toArray(function(c) {
      return c.sort(a);
    }).then(n);
  }
  toArray(e) {
    return this._read((n) => {
      var r = this._ctx;
      if (r.dir === "next" && ve(r, !0) && r.limit > 0) {
        const { valueMapper: s } = r, i = ot(r, r.table.core.schema);
        return r.table.core.query({ trans: n, limit: r.limit, values: !0, query: { index: i, range: r.range } }).then(({ result: o }) => s ? o.map(s) : o);
      }
      {
        const s = [];
        return Je(r, (i) => s.push(i), n, r.table.core).then(() => s);
      }
    }, e);
  }
  offset(e) {
    var n = this._ctx;
    return e <= 0 || (n.offset += e, ve(n) ? St(n, () => {
      var r = e;
      return (s, i) => r === 0 || (r === 1 ? (--r, !1) : (i(() => {
        s.advance(r), r = 0;
      }), !1));
    }) : St(n, () => {
      var r = e;
      return () => --r < 0;
    })), this;
  }
  limit(e) {
    return this._ctx.limit = Math.min(this._ctx.limit, e), St(this._ctx, () => {
      var n = e;
      return function(r, s, i) {
        return --n <= 0 && s(i), n >= 0;
      };
    }, !0), this;
  }
  until(e, n) {
    return xt(this._ctx, function(r, s, i) {
      return !e(r.value) || (s(i), n);
    }), this;
  }
  first(e) {
    return this.limit(1).toArray(function(n) {
      return n[0];
    }).then(e);
  }
  last(e) {
    return this.reverse().first(e);
  }
  filter(e) {
    var n, r;
    return xt(this._ctx, function(s) {
      return e(s.value);
    }), n = this._ctx, r = e, n.isMatch = me(n.isMatch, r), this;
  }
  and(e) {
    return this.filter(e);
  }
  or(e) {
    return new this.db.WhereClause(this._ctx.table, e, this);
  }
  reverse() {
    return this._ctx.dir = this._ctx.dir === "prev" ? "next" : "prev", this._ondirectionchange && this._ondirectionchange(this._ctx.dir), this;
  }
  desc() {
    return this.reverse();
  }
  eachKey(e) {
    var n = this._ctx;
    return n.keysOnly = !n.isMatch, this.each(function(r, s) {
      e(s.key, s);
    });
  }
  eachUniqueKey(e) {
    return this._ctx.unique = "unique", this.eachKey(e);
  }
  eachPrimaryKey(e) {
    var n = this._ctx;
    return n.keysOnly = !n.isMatch, this.each(function(r, s) {
      e(s.primaryKey, s);
    });
  }
  keys(e) {
    var n = this._ctx;
    n.keysOnly = !n.isMatch;
    var r = [];
    return this.each(function(s, i) {
      r.push(i.key);
    }).then(function() {
      return r;
    }).then(e);
  }
  primaryKeys(e) {
    var n = this._ctx;
    if (n.dir === "next" && ve(n, !0) && n.limit > 0)
      return this._read((s) => {
        var i = ot(n, n.table.core.schema);
        return n.table.core.query({ trans: s, values: !1, limit: n.limit, query: { index: i, range: n.range } });
      }).then(({ result: s }) => s).then(e);
    n.keysOnly = !n.isMatch;
    var r = [];
    return this.each(function(s, i) {
      r.push(i.primaryKey);
    }).then(function() {
      return r;
    }).then(e);
  }
  uniqueKeys(e) {
    return this._ctx.unique = "unique", this.keys(e);
  }
  firstKey(e) {
    return this.limit(1).keys(function(n) {
      return n[0];
    }).then(e);
  }
  lastKey(e) {
    return this.reverse().firstKey(e);
  }
  distinct() {
    var e = this._ctx, n = e.index && e.table.schema.idxByName[e.index];
    if (!n || !n.multi)
      return this;
    var r = {};
    return xt(this._ctx, function(s) {
      var i = s.primaryKey.toString(), o = z(r, i);
      return r[i] = !0, !o;
    }), this;
  }
  modify(e) {
    var n = this._ctx;
    return this._write((r) => {
      var s;
      if (typeof e == "function")
        s = e;
      else {
        var i = I(e), o = i.length;
        s = function(f) {
          for (var v = !1, y = 0; y < o; ++y) {
            var g = i[y], b = e[g];
            te(f, g) !== b && (Y(f, g, b), v = !0);
          }
          return v;
        };
      }
      const u = n.table.core, { outbound: a, extractKey: c } = u.schema.primaryKey, h = this.db._options.modifyChunkSize || 200, l = [];
      let d = 0;
      const p = [], m = (f, v) => {
        const { failures: y, numFailures: g } = v;
        d += f - g;
        for (let b of I(y))
          l.push(y[b]);
      };
      return this.clone().primaryKeys().then((f) => {
        const v = (y) => {
          const g = Math.min(h, f.length - y);
          return u.getMany({ trans: r, keys: f.slice(y, y + g), cache: "immutable" }).then((b) => {
            const w = [], C = [], k = a ? [] : null, _ = [];
            for (let x = 0; x < g; ++x) {
              const R = b[x], A = { value: Ve(R), primKey: f[y + x] };
              s.call(A, A.value, A) !== !1 && (A.value == null ? _.push(f[y + x]) : a || L(c(R), c(A.value)) === 0 ? (C.push(A.value), a && k.push(f[y + x])) : (_.push(f[y + x]), w.push(A.value)));
            }
            const O = ve(n) && n.limit === 1 / 0 && (typeof e != "function" || e === Ct) && { index: n.index, range: n.range };
            return Promise.resolve(w.length > 0 && u.mutate({ trans: r, type: "add", values: w }).then((x) => {
              for (let R in x.failures)
                _.splice(parseInt(R), 1);
              m(w.length, x);
            })).then(() => (C.length > 0 || O && typeof e == "object") && u.mutate({ trans: r, type: "put", keys: k, values: C, criteria: O, changeSpec: typeof e != "function" && e }).then((x) => m(C.length, x))).then(() => (_.length > 0 || O && e === Ct) && u.mutate({ trans: r, type: "delete", keys: _, criteria: O }).then((x) => m(_.length, x))).then(() => f.length > y + g && v(y + h));
          });
        };
        return v(0).then(() => {
          if (l.length > 0)
            throw new lt("Error modifying one or more objects", l, d, p);
          return f.length;
        });
      });
    });
  }
  delete() {
    var e = this._ctx, n = e.range;
    return ve(e) && (e.isPrimKey && !Er || n.type === 3) ? this._write((r) => {
      const { primaryKey: s } = e.table.core.schema, i = n;
      return e.table.core.count({ trans: r, query: { index: s, range: i } }).then((o) => e.table.core.mutate({ trans: r, type: "deleteRange", range: i }).then(({ failures: u, lastResult: a, results: c, numFailures: h }) => {
        if (h)
          throw new lt("Could not delete some values", Object.keys(u).map((l) => u[l]), o - h);
        return o - h;
      }));
    }) : this.modify(Ct);
  }
}
const Ct = (t, e) => e.value = null;
function Or(t, e) {
  return t < e ? -1 : t === e ? 0 : 1;
}
function Ar(t, e) {
  return t > e ? -1 : t === e ? 0 : 1;
}
function V(t, e, n) {
  var r = t instanceof Yn ? new t.Collection(t) : t;
  return r._ctx.error = n ? new n(e) : new TypeError(e), r;
}
function be(t) {
  return new t.Collection(t, () => zn("")).limit(0);
}
function Kr(t, e, n, r, s, i) {
  for (var o = Math.min(t.length, r.length), u = -1, a = 0; a < o; ++a) {
    var c = e[a];
    if (c !== r[a])
      return s(t[a], n[a]) < 0 ? t.substr(0, a) + n[a] + n.substr(a + 1) : s(t[a], r[a]) < 0 ? t.substr(0, a) + r[a] + n.substr(a + 1) : u >= 0 ? t.substr(0, u) + e[u] + n.substr(u + 1) : null;
    s(t[a], c) < 0 && (u = a);
  }
  return o < r.length && i === "next" ? t + n.substr(t.length) : o < t.length && i === "prev" ? t.substr(0, n.length) : u < 0 ? null : t.substr(0, u) + r[u] + n.substr(u + 1);
}
function Ze(t, e, n, r) {
  var s, i, o, u, a, c, h, l = n.length;
  if (!n.every((f) => typeof f == "string"))
    return V(t, Un);
  function d(f) {
    s = function(y) {
      return y === "next" ? (g) => g.toUpperCase() : (g) => g.toLowerCase();
    }(f), i = function(y) {
      return y === "next" ? (g) => g.toLowerCase() : (g) => g.toUpperCase();
    }(f), o = f === "next" ? Or : Ar;
    var v = n.map(function(y) {
      return { lower: i(y), upper: s(y) };
    }).sort(function(y, g) {
      return o(y.lower, g.lower);
    });
    u = v.map(function(y) {
      return y.upper;
    }), a = v.map(function(y) {
      return y.lower;
    }), c = f, h = f === "next" ? "" : r;
  }
  d("next");
  var p = new t.Collection(t, () => re(u[0], a[l - 1] + r));
  p._ondirectionchange = function(f) {
    d(f);
  };
  var m = 0;
  return p._addAlgorithm(function(f, v, y) {
    var g = f.key;
    if (typeof g != "string")
      return !1;
    var b = i(g);
    if (e(b, a, m))
      return !0;
    for (var w = null, C = m; C < l; ++C) {
      var k = Kr(g, b, u[C], a[C], o, c);
      k === null && w === null ? m = C + 1 : (w === null || o(w, k) > 0) && (w = k);
    }
    return v(w !== null ? function() {
      f.continue(w + h);
    } : y), !1;
  }), p;
}
function re(t, e, n, r) {
  return { type: 2, lower: t, upper: e, lowerOpen: n, upperOpen: r };
}
function zn(t) {
  return { type: 1, lower: t, upper: t };
}
class Yn {
  get Collection() {
    return this._ctx.table.db.Collection;
  }
  between(e, n, r, s) {
    r = r !== !1, s = s === !0;
    try {
      return this._cmp(e, n) > 0 || this._cmp(e, n) === 0 && (r || s) && (!r || !s) ? be(this) : new this.Collection(this, () => re(e, n, !r, !s));
    } catch {
      return V(this, X);
    }
  }
  equals(e) {
    return e == null ? V(this, X) : new this.Collection(this, () => zn(e));
  }
  above(e) {
    return e == null ? V(this, X) : new this.Collection(this, () => re(e, void 0, !0));
  }
  aboveOrEqual(e) {
    return e == null ? V(this, X) : new this.Collection(this, () => re(e, void 0, !1));
  }
  below(e) {
    return e == null ? V(this, X) : new this.Collection(this, () => re(void 0, e, !1, !0));
  }
  belowOrEqual(e) {
    return e == null ? V(this, X) : new this.Collection(this, () => re(void 0, e));
  }
  startsWith(e) {
    return typeof e != "string" ? V(this, Un) : this.between(e, e + he, !0, !0);
  }
  startsWithIgnoreCase(e) {
    return e === "" ? this.startsWith(e) : Ze(this, (n, r) => n.indexOf(r[0]) === 0, [e], he);
  }
  equalsIgnoreCase(e) {
    return Ze(this, (n, r) => n === r[0], [e], "");
  }
  anyOfIgnoreCase() {
    var e = J.apply(we, arguments);
    return e.length === 0 ? be(this) : Ze(this, (n, r) => r.indexOf(n) !== -1, e, "");
  }
  startsWithAnyOfIgnoreCase() {
    var e = J.apply(we, arguments);
    return e.length === 0 ? be(this) : Ze(this, (n, r) => r.some((s) => n.indexOf(s) === 0), e, he);
  }
  anyOf() {
    const e = J.apply(we, arguments);
    let n = this._cmp;
    try {
      e.sort(n);
    } catch {
      return V(this, X);
    }
    if (e.length === 0)
      return be(this);
    const r = new this.Collection(this, () => re(e[0], e[e.length - 1]));
    r._ondirectionchange = (i) => {
      n = i === "next" ? this._ascending : this._descending, e.sort(n);
    };
    let s = 0;
    return r._addAlgorithm((i, o, u) => {
      const a = i.key;
      for (; n(a, e[s]) > 0; )
        if (++s, s === e.length)
          return o(u), !1;
      return n(a, e[s]) === 0 || (o(() => {
        i.continue(e[s]);
      }), !1);
    }), r;
  }
  notEqual(e) {
    return this.inAnyRange([[Mt, e], [e, this.db._maxKey]], { includeLowers: !1, includeUppers: !1 });
  }
  noneOf() {
    const e = J.apply(we, arguments);
    if (e.length === 0)
      return new this.Collection(this);
    try {
      e.sort(this._ascending);
    } catch {
      return V(this, X);
    }
    const n = e.reduce((r, s) => r ? r.concat([[r[r.length - 1][1], s]]) : [[Mt, s]], null);
    return n.push([e[e.length - 1], this.db._maxKey]), this.inAnyRange(n, { includeLowers: !1, includeUppers: !1 });
  }
  inAnyRange(e, n) {
    const r = this._cmp, s = this._ascending, i = this._descending, o = this._min, u = this._max;
    if (e.length === 0)
      return be(this);
    if (!e.every((g) => g[0] !== void 0 && g[1] !== void 0 && s(g[0], g[1]) <= 0))
      return V(this, "First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower", P.InvalidArgument);
    const a = !n || n.includeLowers !== !1, c = n && n.includeUppers === !0;
    let h, l = s;
    function d(g, b) {
      return l(g[0], b[0]);
    }
    try {
      h = e.reduce(function(g, b) {
        let w = 0, C = g.length;
        for (; w < C; ++w) {
          const k = g[w];
          if (r(b[0], k[1]) < 0 && r(b[1], k[0]) > 0) {
            k[0] = o(k[0], b[0]), k[1] = u(k[1], b[1]);
            break;
          }
        }
        return w === C && g.push(b), g;
      }, []), h.sort(d);
    } catch {
      return V(this, X);
    }
    let p = 0;
    const m = c ? (g) => s(g, h[p][1]) > 0 : (g) => s(g, h[p][1]) >= 0, f = a ? (g) => i(g, h[p][0]) > 0 : (g) => i(g, h[p][0]) >= 0;
    let v = m;
    const y = new this.Collection(this, () => re(h[0][0], h[h.length - 1][1], !a, !c));
    return y._ondirectionchange = (g) => {
      g === "next" ? (v = m, l = s) : (v = f, l = i), h.sort(d);
    }, y._addAlgorithm((g, b, w) => {
      for (var C = g.key; v(C); )
        if (++p, p === h.length)
          return b(w), !1;
      return !!function(k) {
        return !m(k) && !f(k);
      }(C) || (this._cmp(C, h[p][1]) === 0 || this._cmp(C, h[p][0]) === 0 || b(() => {
        l === s ? g.continue(h[p][0]) : g.continue(h[p][1]);
      }), !1);
    }), y;
  }
  startsWithAnyOf() {
    const e = J.apply(we, arguments);
    return e.every((n) => typeof n == "string") ? e.length === 0 ? be(this) : this.inAnyRange(e.map((n) => [n, n + he])) : V(this, "startsWithAnyOf() only works with strings");
  }
}
function H(t) {
  return N(function(e) {
    return qe(e), t(e.target.error), !1;
  });
}
function qe(t) {
  t.stopPropagation && t.stopPropagation(), t.preventDefault && t.preventDefault();
}
const Le = "storagemutated", ie = "x-storagemutated-1", ue = Ie(null, Le);
class $r {
  _lock() {
    return Ke(!E.global), ++this._reculock, this._reculock !== 1 || E.global || (E.lockOwnerFor = this), this;
  }
  _unlock() {
    if (Ke(!E.global), --this._reculock == 0)
      for (E.global || (E.lockOwnerFor = null); this._blockedFuncs.length > 0 && !this._locked(); ) {
        var e = this._blockedFuncs.shift();
        try {
          Te(e[1], e[0]);
        } catch {
        }
      }
    return this;
  }
  _locked() {
    return this._reculock && E.lockOwnerFor !== this;
  }
  create(e) {
    if (!this.mode)
      return this;
    const n = this.db.idbdb, r = this.db._state.dbOpenError;
    if (Ke(!this.idbtrans), !e && !n)
      switch (r && r.name) {
        case "DatabaseClosedError":
          throw new P.DatabaseClosed(r);
        case "MissingAPIError":
          throw new P.MissingAPI(r.message, r);
        default:
          throw new P.OpenFailed(r);
      }
    if (!this.active)
      throw new P.TransactionInactive();
    return Ke(this._completion._state === null), (e = this.idbtrans = e || (this.db.core ? this.db.core.transaction(this.storeNames, this.mode, { durability: this.chromeTransactionDurability }) : n.transaction(this.storeNames, this.mode, { durability: this.chromeTransactionDurability }))).onerror = N((s) => {
      qe(s), this._reject(e.error);
    }), e.onabort = N((s) => {
      qe(s), this.active && this._reject(new P.Abort(e.error)), this.active = !1, this.on("abort").fire(s);
    }), e.oncomplete = N(() => {
      this.active = !1, this._resolve(), "mutatedParts" in e && ue.storagemutated.fire(e.mutatedParts);
    }), this;
  }
  _promise(e, n, r) {
    if (e === "readwrite" && this.mode !== "readwrite")
      return D(new P.ReadOnly("Transaction is readonly"));
    if (!this.active)
      return D(new P.TransactionInactive());
    if (this._locked())
      return new S((i, o) => {
        this._blockedFuncs.push([() => {
          this._promise(e, n, r).then(i, o);
        }, E]);
      });
    if (r)
      return oe(() => {
        var i = new S((o, u) => {
          this._lock();
          const a = n(o, u, this);
          a && a.then && a.then(o, u);
        });
        return i.finally(() => this._unlock()), i._lib = !0, i;
      });
    var s = new S((i, o) => {
      var u = n(i, o, this);
      u && u.then && u.then(i, o);
    });
    return s._lib = !0, s;
  }
  _root() {
    return this.parent ? this.parent._root() : this;
  }
  waitFor(e) {
    var n = this._root();
    const r = S.resolve(e);
    if (n._waitingFor)
      n._waitingFor = n._waitingFor.then(() => r);
    else {
      n._waitingFor = r, n._waitingQueue = [];
      var s = n.idbtrans.objectStore(n.storeNames[0]);
      (function o() {
        for (++n._spinCount; n._waitingQueue.length; )
          n._waitingQueue.shift()();
        n._waitingFor && (s.get(-1 / 0).onsuccess = o);
      })();
    }
    var i = n._waitingFor;
    return new S((o, u) => {
      r.then((a) => n._waitingQueue.push(N(o.bind(null, a))), (a) => n._waitingQueue.push(N(u.bind(null, a)))).finally(() => {
        n._waitingFor === i && (n._waitingFor = null);
      });
    });
  }
  abort() {
    this.active && (this.active = !1, this.idbtrans && this.idbtrans.abort(), this._reject(new P.Abort()));
  }
  table(e) {
    const n = this._memoizedTables || (this._memoizedTables = {});
    if (z(n, e))
      return n[e];
    const r = this.schema[e];
    if (!r)
      throw new P.NotFound("Table " + e + " not part of transaction");
    const s = new this.db.Table(e, r, this);
    return s.core = this.db.core.table(e), n[e] = s, s;
  }
}
function qt(t, e, n, r, s, i, o) {
  return { name: t, keyPath: e, unique: n, multi: r, auto: s, compound: i, src: (n && !o ? "&" : "") + (r ? "*" : "") + (s ? "++" : "") + Hn(e) };
}
function Hn(t) {
  return typeof t == "string" ? t : t ? "[" + [].join.call(t, "+") + "]" : "";
}
function Gn(t, e, n) {
  return { name: t, primKey: e, indexes: n, mappedClass: null, idxByName: En(n, (r) => [r.name, r]) };
}
let Ue = (t) => {
  try {
    return t.only([[]]), Ue = () => [[]], [[]];
  } catch {
    return Ue = () => he, he;
  }
};
function Lt(t) {
  return t == null ? () => {
  } : typeof t == "string" ? function(e) {
    return e.split(".").length === 1 ? (n) => n[e] : (n) => te(n, e);
  }(t) : (e) => te(e, t);
}
function wn(t) {
  return [].slice.call(t);
}
let Nr = 0;
function De(t) {
  return t == null ? ":id" : typeof t == "string" ? t : `[${t.join("+")}]`;
}
function Rr(t, e, n) {
  function r(a) {
    if (a.type === 3)
      return null;
    if (a.type === 4)
      throw new Error("Cannot convert never type to IDBKeyRange");
    const { lower: c, upper: h, lowerOpen: l, upperOpen: d } = a;
    return c === void 0 ? h === void 0 ? null : e.upperBound(h, !!d) : h === void 0 ? e.lowerBound(c, !!l) : e.bound(c, h, !!l, !!d);
  }
  const { schema: s, hasGetAll: i } = function(a, c) {
    const h = wn(a.objectStoreNames);
    return { schema: { name: a.name, tables: h.map((l) => c.objectStore(l)).map((l) => {
      const { keyPath: d, autoIncrement: p } = l, m = M(d), f = d == null, v = {}, y = { name: l.name, primaryKey: { name: null, isPrimaryKey: !0, outbound: f, compound: m, keyPath: d, autoIncrement: p, unique: !0, extractKey: Lt(d) }, indexes: wn(l.indexNames).map((g) => l.index(g)).map((g) => {
        const { name: b, unique: w, multiEntry: C, keyPath: k } = g, _ = { name: b, compound: M(k), keyPath: k, unique: w, multiEntry: C, extractKey: Lt(k) };
        return v[De(k)] = _, _;
      }), getIndexByKeyPath: (g) => v[De(g)] };
      return v[":id"] = y.primaryKey, d != null && (v[De(d)] = y.primaryKey), y;
    }) }, hasGetAll: h.length > 0 && "getAll" in c.objectStore(h[0]) && !(typeof navigator < "u" && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604) };
  }(t, n), o = s.tables.map((a) => function(c) {
    const h = c.name;
    return { name: h, schema: c, mutate: function({ trans: l, type: d, keys: p, values: m, range: f }) {
      return new Promise((v, y) => {
        v = N(v);
        const g = l.objectStore(h), b = g.keyPath == null, w = d === "put" || d === "add";
        if (!w && d !== "delete" && d !== "deleteRange")
          throw new Error("Invalid operation type: " + d);
        const { length: C } = p || m || { length: 1 };
        if (p && m && p.length !== m.length)
          throw new Error("Given keys array must have same length as given values array.");
        if (C === 0)
          return v({ numFailures: 0, failures: {}, results: [], lastResult: void 0 });
        let k;
        const _ = [], O = [];
        let x = 0;
        const R = (q) => {
          ++x, qe(q);
        };
        if (d === "deleteRange") {
          if (f.type === 4)
            return v({ numFailures: x, failures: O, results: [], lastResult: void 0 });
          f.type === 3 ? _.push(k = g.clear()) : _.push(k = g.delete(r(f)));
        } else {
          const [q, B] = w ? b ? [m, p] : [m, null] : [p, null];
          if (w)
            for (let j = 0; j < C; ++j)
              _.push(k = B && B[j] !== void 0 ? g[d](q[j], B[j]) : g[d](q[j])), k.onerror = R;
          else
            for (let j = 0; j < C; ++j)
              _.push(k = g[d](q[j])), k.onerror = R;
        }
        const A = (q) => {
          const B = q.target.result;
          _.forEach((j, ge) => j.error != null && (O[ge] = j.error)), v({ numFailures: x, failures: O, results: d === "delete" ? p : _.map((j) => j.result), lastResult: B });
        };
        k.onerror = (q) => {
          R(q), A(q);
        }, k.onsuccess = A;
      });
    }, getMany: ({ trans: l, keys: d }) => new Promise((p, m) => {
      p = N(p);
      const f = l.objectStore(h), v = d.length, y = new Array(v);
      let g, b = 0, w = 0;
      const C = (_) => {
        const O = _.target;
        y[O._pos] = O.result, ++w === b && p(y);
      }, k = H(m);
      for (let _ = 0; _ < v; ++_)
        d[_] != null && (g = f.get(d[_]), g._pos = _, g.onsuccess = C, g.onerror = k, ++b);
      b === 0 && p(y);
    }), get: ({ trans: l, key: d }) => new Promise((p, m) => {
      p = N(p);
      const f = l.objectStore(h).get(d);
      f.onsuccess = (v) => p(v.target.result), f.onerror = H(m);
    }), query: function(l) {
      return (d) => new Promise((p, m) => {
        p = N(p);
        const { trans: f, values: v, limit: y, query: g } = d, b = y === 1 / 0 ? void 0 : y, { index: w, range: C } = g, k = f.objectStore(h), _ = w.isPrimaryKey ? k : k.index(w.name), O = r(C);
        if (y === 0)
          return p({ result: [] });
        if (l) {
          const x = v ? _.getAll(O, b) : _.getAllKeys(O, b);
          x.onsuccess = (R) => p({ result: R.target.result }), x.onerror = H(m);
        } else {
          let x = 0;
          const R = v || !("openKeyCursor" in _) ? _.openCursor(O) : _.openKeyCursor(O), A = [];
          R.onsuccess = (q) => {
            const B = R.result;
            return B ? (A.push(v ? B.value : B.primaryKey), ++x === y ? p({ result: A }) : void B.continue()) : p({ result: A });
          }, R.onerror = H(m);
        }
      });
    }(i), openCursor: function({ trans: l, values: d, query: p, reverse: m, unique: f }) {
      return new Promise((v, y) => {
        v = N(v);
        const { index: g, range: b } = p, w = l.objectStore(h), C = g.isPrimaryKey ? w : w.index(g.name), k = m ? f ? "prevunique" : "prev" : f ? "nextunique" : "next", _ = d || !("openKeyCursor" in C) ? C.openCursor(r(b), k) : C.openKeyCursor(r(b), k);
        _.onerror = H(y), _.onsuccess = N((O) => {
          const x = _.result;
          if (!x)
            return void v(null);
          x.___id = ++Nr, x.done = !1;
          const R = x.continue.bind(x);
          let A = x.continuePrimaryKey;
          A && (A = A.bind(x));
          const q = x.advance.bind(x), B = () => {
            throw new Error("Cursor not stopped");
          };
          x.trans = l, x.stop = x.continue = x.continuePrimaryKey = x.advance = () => {
            throw new Error("Cursor not started");
          }, x.fail = N(y), x.next = function() {
            let j = 1;
            return this.start(() => j-- ? this.continue() : this.stop()).then(() => this);
          }, x.start = (j) => {
            const ge = new Promise((W, le) => {
              W = N(W), _.onerror = H(le), x.fail = le, x.stop = (Oe) => {
                x.stop = x.continue = x.continuePrimaryKey = x.advance = B, W(Oe);
              };
            }), ye = () => {
              if (_.result)
                try {
                  j();
                } catch (W) {
                  x.fail(W);
                }
              else
                x.done = !0, x.start = () => {
                  throw new Error("Cursor behind last entry");
                }, x.stop();
            };
            return _.onsuccess = N((W) => {
              _.onsuccess = ye, ye();
            }), x.continue = R, x.continuePrimaryKey = A, x.advance = q, ye(), ge;
          }, v(x);
        }, y);
      });
    }, count({ query: l, trans: d }) {
      const { index: p, range: m } = l;
      return new Promise((f, v) => {
        const y = d.objectStore(h), g = p.isPrimaryKey ? y : y.index(p.name), b = r(m), w = b ? g.count(b) : g.count();
        w.onsuccess = N((C) => f(C.target.result)), w.onerror = H(v);
      });
    } };
  }(a)), u = {};
  return o.forEach((a) => u[a.name] = a), { stack: "dbcore", transaction: t.transaction.bind(t), table(a) {
    if (!u[a])
      throw new Error(`Table '${a}' not found`);
    return u[a];
  }, MIN_KEY: -1 / 0, MAX_KEY: Ue(e), schema: s };
}
function Ut({ _novip: t }, e) {
  const n = e.db, r = function(s, i, { IDBKeyRange: o, indexedDB: u }, a) {
    return { dbcore: function(c, h) {
      return h.reduce((l, { create: d }) => ({ ...l, ...d(l) }), c);
    }(Rr(i, o, a), s.dbcore) };
  }(t._middlewares, n, t._deps, e);
  t.core = r.dbcore, t.tables.forEach((s) => {
    const i = s.name;
    t.core.schema.tables.some((o) => o.name === i) && (s.core = t.core.table(i), t[i] instanceof t.Table && (t[i].core = s.core));
  });
}
function pt({ _novip: t }, e, n, r) {
  n.forEach((s) => {
    const i = r[s];
    e.forEach((o) => {
      const u = Jt(o, s);
      (!u || "value" in u && u.value === void 0) && (o === t.Transaction.prototype || o instanceof t.Transaction ? ee(o, s, { get() {
        return this.table(s);
      }, set(a) {
        xn(this, s, { value: a, writable: !0, configurable: !0, enumerable: !0 });
      } }) : o[s] = new t.Table(s, i));
    });
  });
}
function Wt({ _novip: t }, e) {
  e.forEach((n) => {
    for (let r in n)
      n[r] instanceof t.Table && delete n[r];
  });
}
function jr(t, e) {
  return t._cfg.version - e._cfg.version;
}
function Ir(t, e, n, r) {
  const s = t._dbSchema, i = t._createTransaction("readwrite", t._storeNames, s);
  i.create(n), i._completion.catch(r);
  const o = i._reject.bind(i), u = E.transless || E;
  oe(() => {
    E.trans = i, E.transless = u, e === 0 ? (I(s).forEach((a) => {
      Et(n, a, s[a].primKey, s[a].indexes);
    }), Ut(t, n), S.follow(() => t.on.populate.fire(i)).catch(o)) : function({ _novip: a }, c, h, l) {
      const d = [], p = a._versions;
      let m = a._dbSchema = zt(a, a.idbdb, l), f = !1;
      const v = p.filter((g) => g._cfg.version >= c);
      function y() {
        return d.length ? S.resolve(d.shift()(h.idbtrans)).then(y) : S.resolve();
      }
      return v.forEach((g) => {
        d.push(() => {
          const b = m, w = g._cfg.dbschema;
          Yt(a, b, l), Yt(a, w, l), m = a._dbSchema = w;
          const C = Xn(b, w);
          C.add.forEach((_) => {
            Et(l, _[0], _[1].primKey, _[1].indexes);
          }), C.change.forEach((_) => {
            if (_.recreate)
              throw new P.Upgrade("Not yet support for changing primary key");
            {
              const O = l.objectStore(_.name);
              _.add.forEach((x) => Vt(O, x)), _.change.forEach((x) => {
                O.deleteIndex(x.name), Vt(O, x);
              }), _.del.forEach((x) => O.deleteIndex(x));
            }
          });
          const k = g._cfg.contentUpgrade;
          if (k && g._cfg.version > c) {
            Ut(a, l), h._memoizedTables = {}, f = !0;
            let _ = Pn(w);
            C.del.forEach((A) => {
              _[A] = b[A];
            }), Wt(a, [a.Transaction.prototype]), pt(a, [a.Transaction.prototype], I(_), _), h.schema = _;
            const O = Zt(k);
            let x;
            O && Pe();
            const R = S.follow(() => {
              if (x = k(h), x && O) {
                var A = ne.bind(null, null);
                x.then(A, A);
              }
            });
            return x && typeof x.then == "function" ? S.resolve(x) : R.then(() => x);
          }
        }), d.push((b) => {
          (!f || !Cr) && function(w, C) {
            [].slice.call(C.db.objectStoreNames).forEach((k) => w[k] == null && C.db.deleteObjectStore(k));
          }(g._cfg.dbschema, b), Wt(a, [a.Transaction.prototype]), pt(a, [a.Transaction.prototype], a._storeNames, a._dbSchema), h.schema = a._dbSchema;
        });
      }), y().then(() => {
        var g, b;
        b = l, I(g = m).forEach((w) => {
          b.db.objectStoreNames.contains(w) || Et(b, w, g[w].primKey, g[w].indexes);
        });
      });
    }(t, e, i, n).catch(o);
  });
}
function Xn(t, e) {
  const n = { del: [], add: [], change: [] };
  let r;
  for (r in t)
    e[r] || n.del.push(r);
  for (r in e) {
    const s = t[r], i = e[r];
    if (s) {
      const o = { name: r, def: i, recreate: !1, del: [], add: [], change: [] };
      if ("" + (s.primKey.keyPath || "") != "" + (i.primKey.keyPath || "") || s.primKey.auto !== i.primKey.auto && !gt)
        o.recreate = !0, n.change.push(o);
      else {
        const u = s.idxByName, a = i.idxByName;
        let c;
        for (c in u)
          a[c] || o.del.push(c);
        for (c in a) {
          const h = u[c], l = a[c];
          h ? h.src !== l.src && o.change.push(l) : o.add.push(l);
        }
        (o.del.length > 0 || o.add.length > 0 || o.change.length > 0) && n.change.push(o);
      }
    } else
      n.add.push([r, i]);
  }
  return n;
}
function Et(t, e, n, r) {
  const s = t.db.createObjectStore(e, n.keyPath ? { keyPath: n.keyPath, autoIncrement: n.auto } : { autoIncrement: n.auto });
  return r.forEach((i) => Vt(s, i)), s;
}
function Vt(t, e) {
  t.createIndex(e.name, e.keyPath, { unique: e.unique, multiEntry: e.multi });
}
function zt(t, e, n) {
  const r = {};
  return ut(e.objectStoreNames, 0).forEach((s) => {
    const i = n.objectStore(s);
    let o = i.keyPath;
    const u = qt(Hn(o), o || "", !1, !1, !!i.autoIncrement, o && typeof o != "string", !0), a = [];
    for (let h = 0; h < i.indexNames.length; ++h) {
      const l = i.index(i.indexNames[h]);
      o = l.keyPath;
      var c = qt(l.name, o, !!l.unique, !!l.multiEntry, !1, o && typeof o != "string", !1);
      a.push(c);
    }
    r[s] = Gn(s, u, a);
  }), r;
}
function Yt({ _novip: t }, e, n) {
  const r = n.db.objectStoreNames;
  for (let s = 0; s < r.length; ++s) {
    const i = r[s], o = n.objectStore(i);
    t._hasGetAll = "getAll" in o;
    for (let u = 0; u < o.indexNames.length; ++u) {
      const a = o.indexNames[u], c = o.index(a).keyPath, h = typeof c == "string" ? c : "[" + ut(c).join("+") + "]";
      if (e[i]) {
        const l = e[i].idxByName[h];
        l && (l.name = a, delete e[i].idxByName[h], e[i].idxByName[a] = l);
      }
    }
  }
  typeof navigator < "u" && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && $.WorkerGlobalScope && $ instanceof $.WorkerGlobalScope && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604 && (t._hasGetAll = !1);
}
class Dr {
  _parseStoresSpec(e, n) {
    I(e).forEach((r) => {
      if (e[r] !== null) {
        var s = e[r].split(",").map((o, u) => {
          const a = (o = o.trim()).replace(/([&*]|\+\+)/g, ""), c = /^\[/.test(a) ? a.match(/^\[(.*)\]$/)[1].split("+") : a;
          return qt(a, c || null, /\&/.test(o), /\*/.test(o), /\+\+/.test(o), M(c), u === 0);
        }), i = s.shift();
        if (i.multi)
          throw new P.Schema("Primary key cannot be multi-valued");
        s.forEach((o) => {
          if (o.auto)
            throw new P.Schema("Only primary key can be marked as autoIncrement (++)");
          if (!o.keyPath)
            throw new P.Schema("Index must have a name and cannot be an empty string");
        }), n[r] = Gn(r, i, s);
      }
    });
  }
  stores(e) {
    const n = this.db;
    this._cfg.storesSource = this._cfg.storesSource ? U(this._cfg.storesSource, e) : e;
    const r = n._versions, s = {};
    let i = {};
    return r.forEach((o) => {
      U(s, o._cfg.storesSource), i = o._cfg.dbschema = {}, o._parseStoresSpec(s, i);
    }), n._dbSchema = i, Wt(n, [n._allTables, n, n.Transaction.prototype]), pt(n, [n._allTables, n, n.Transaction.prototype, this._cfg.tables], I(i), i), n._storeNames = I(i), this;
  }
  upgrade(e) {
    return this._cfg.contentUpgrade = nn(this._cfg.contentUpgrade || K, e), this;
  }
}
function an(t, e) {
  let n = t._dbNamesDB;
  return n || (n = t._dbNamesDB = new Se(yt, { addons: [], indexedDB: t, IDBKeyRange: e }), n.version(1).stores({ dbnames: "name" })), n.table("dbnames");
}
function un(t) {
  return t && typeof t.databases == "function";
}
function Ht(t) {
  return oe(function() {
    return E.letThrough = !0, t();
  });
}
function Br() {
  var t;
  return !navigator.userAgentData && /Safari\//.test(navigator.userAgent) && !/Chrom(e|ium)\//.test(navigator.userAgent) && indexedDB.databases ? new Promise(function(e) {
    var n = function() {
      return indexedDB.databases().finally(e);
    };
    t = setInterval(n, 100), n();
  }).finally(function() {
    return clearInterval(t);
  }) : Promise.resolve();
}
function Fr(t) {
  const e = t._state, { indexedDB: n } = t._deps;
  if (e.isBeingOpened || t.idbdb)
    return e.dbReadyPromise.then(() => e.dbOpenError ? D(e.dbOpenError) : t);
  G && (e.openCanceller._stackHolder = Ee()), e.isBeingOpened = !0, e.dbOpenError = null, e.openComplete = !1;
  const r = e.openCanceller;
  function s() {
    if (e.openCanceller !== r)
      throw new P.DatabaseClosed("db.open() was cancelled");
  }
  let i = e.dbReadyResolve, o = null, u = !1;
  return S.race([r, (typeof navigator > "u" ? S.resolve() : Br()).then(() => new S((a, c) => {
    if (s(), !n)
      throw new P.MissingAPI();
    const h = t.name, l = e.autoSchema ? n.open(h) : n.open(h, Math.round(10 * t.verno));
    if (!l)
      throw new P.MissingAPI();
    l.onerror = H(c), l.onblocked = N(t._fireOnBlocked), l.onupgradeneeded = N((d) => {
      if (o = l.transaction, e.autoSchema && !t._options.allowEmptyDB) {
        l.onerror = qe, o.abort(), l.result.close();
        const m = n.deleteDatabase(h);
        m.onsuccess = m.onerror = N(() => {
          c(new P.NoSuchDatabase(`Database ${h} doesnt exist`));
        });
      } else {
        o.onerror = H(c);
        var p = d.oldVersion > Math.pow(2, 62) ? 0 : d.oldVersion;
        u = p < 1, t._novip.idbdb = l.result, Ir(t, p / 10, o, c);
      }
    }, c), l.onsuccess = N(() => {
      o = null;
      const d = t._novip.idbdb = l.result, p = ut(d.objectStoreNames);
      if (p.length > 0)
        try {
          const f = d.transaction((m = p).length === 1 ? m[0] : m, "readonly");
          e.autoSchema ? function({ _novip: v }, y, g) {
            v.verno = y.version / 10;
            const b = v._dbSchema = zt(0, y, g);
            v._storeNames = ut(y.objectStoreNames, 0), pt(v, [v._allTables], I(b), b);
          }(t, d, f) : (Yt(t, t._dbSchema, f), function(v, y) {
            const g = Xn(zt(0, v.idbdb, y), v._dbSchema);
            return !(g.add.length || g.change.some((b) => b.add.length || b.change.length));
          }(t, f) || console.warn("Dexie SchemaDiff: Schema was extended without increasing the number passed to db.version(). Some queries may fail.")), Ut(t, f);
        } catch {
        }
      var m;
      je.push(t), d.onversionchange = N((f) => {
        e.vcFired = !0, t.on("versionchange").fire(f);
      }), d.onclose = N((f) => {
        t.on("close").fire(f);
      }), u && function({ indexedDB: f, IDBKeyRange: v }, y) {
        !un(f) && y !== yt && an(f, v).put({ name: y }).catch(K);
      }(t._deps, h), a();
    }, c);
  }))]).then(() => (s(), e.onReadyBeingFired = [], S.resolve(Ht(() => t.on.ready.fire(t.vip))).then(function a() {
    if (e.onReadyBeingFired.length > 0) {
      let c = e.onReadyBeingFired.reduce(nn, K);
      return e.onReadyBeingFired = [], S.resolve(Ht(() => c(t.vip))).then(a);
    }
  }))).finally(() => {
    e.onReadyBeingFired = null, e.isBeingOpened = !1;
  }).then(() => t).catch((a) => {
    e.dbOpenError = a;
    try {
      o && o.abort();
    } catch {
    }
    return r === e.openCanceller && t._close(), D(a);
  }).finally(() => {
    e.openComplete = !0, i();
  });
}
function Gt(t) {
  var e = (i) => t.next(i), n = s(e), r = s((i) => t.throw(i));
  function s(i) {
    return (o) => {
      var u = i(o), a = u.value;
      return u.done ? a : a && typeof a.then == "function" ? a.then(n, r) : M(a) ? Promise.all(a).then(n, r) : n(a);
    };
  }
  return s(e)();
}
function Mr(t, e, n) {
  var r = arguments.length;
  if (r < 2)
    throw new P.InvalidArgument("Too few arguments");
  for (var s = new Array(r - 1); --r; )
    s[r - 1] = arguments[r];
  return n = s.pop(), [t, Tn(s), n];
}
function Qn(t, e, n, r, s) {
  return S.resolve().then(() => {
    const i = E.transless || E, o = t._createTransaction(e, n, t._dbSchema, r), u = { trans: o, transless: i };
    if (r)
      o.idbtrans = r.idbtrans;
    else
      try {
        o.create(), t._state.PR1398_maxLoop = 3;
      } catch (l) {
        return l.name === tn.InvalidState && t.isOpen() && --t._state.PR1398_maxLoop > 0 ? (console.warn("Dexie: Need to reopen db"), t._close(), t.open().then(() => Qn(t, e, n, null, s))) : D(l);
      }
    const a = Zt(s);
    let c;
    a && Pe();
    const h = S.follow(() => {
      if (c = s.call(o, o), c)
        if (a) {
          var l = ne.bind(null, null);
          c.then(l, l);
        } else
          typeof c.next == "function" && typeof c.throw == "function" && (c = Gt(c));
    }, u);
    return (c && typeof c.then == "function" ? S.resolve(c).then((l) => o.active ? l : D(new P.PrematureCommit("Transaction committed too early. See http://bit.ly/2kdckMn"))) : h.then(() => c)).then((l) => (r && o._resolve(), o._completion.then(() => l))).catch((l) => (o._reject(l), D(l)));
  });
}
function et(t, e, n) {
  const r = M(t) ? t.slice() : [t];
  for (let s = 0; s < n; ++s)
    r.push(e);
  return r;
}
const qr = { stack: "dbcore", name: "VirtualIndexMiddleware", level: 1, create: function(t) {
  return { ...t, table(e) {
    const n = t.table(e), { schema: r } = n, s = {}, i = [];
    function o(c, h, l) {
      const d = De(c), p = s[d] = s[d] || [], m = c == null ? 0 : typeof c == "string" ? 1 : c.length, f = h > 0, v = { ...l, isVirtual: f, keyTail: h, keyLength: m, extractKey: Lt(c), unique: !f && l.unique };
      return p.push(v), v.isPrimaryKey || i.push(v), m > 1 && o(m === 2 ? c[0] : c.slice(0, m - 1), h + 1, l), p.sort((y, g) => y.keyTail - g.keyTail), v;
    }
    const u = o(r.primaryKey.keyPath, 0, r.primaryKey);
    s[":id"] = [u];
    for (const c of r.indexes)
      o(c.keyPath, 0, c);
    function a(c) {
      const h = c.query.index;
      return h.isVirtual ? { ...c, query: { index: h, range: (l = c.query.range, d = h.keyTail, { type: l.type === 1 ? 2 : l.type, lower: et(l.lower, l.lowerOpen ? t.MAX_KEY : t.MIN_KEY, d), lowerOpen: !0, upper: et(l.upper, l.upperOpen ? t.MIN_KEY : t.MAX_KEY, d), upperOpen: !0 }) } } : c;
      var l, d;
    }
    return { ...n, schema: { ...r, primaryKey: u, indexes: i, getIndexByKeyPath: function(c) {
      const h = s[De(c)];
      return h && h[0];
    } }, count: (c) => n.count(a(c)), query: (c) => n.query(a(c)), openCursor(c) {
      const { keyTail: h, isVirtual: l, keyLength: d } = c.query.index;
      return l ? n.openCursor(a(c)).then((p) => p && function(m) {
        return Object.create(m, { continue: { value: function(f) {
          f != null ? m.continue(et(f, c.reverse ? t.MAX_KEY : t.MIN_KEY, h)) : c.unique ? m.continue(m.key.slice(0, d).concat(c.reverse ? t.MIN_KEY : t.MAX_KEY, h)) : m.continue();
        } }, continuePrimaryKey: { value(f, v) {
          m.continuePrimaryKey(et(f, t.MAX_KEY, h), v);
        } }, primaryKey: { get: () => m.primaryKey }, key: { get() {
          const f = m.key;
          return d === 1 ? f[0] : f.slice(0, d);
        } }, value: { get: () => m.value } });
      }(p)) : n.openCursor(c);
    } };
  } };
} };
function ln(t, e, n, r) {
  return n = n || {}, r = r || "", I(t).forEach((s) => {
    if (z(e, s)) {
      var i = t[s], o = e[s];
      if (typeof i == "object" && typeof o == "object" && i && o) {
        const u = Tt(i);
        u !== Tt(o) ? n[r + s] = e[s] : u === "Object" ? ln(i, o, n, r + s + ".") : i !== o && (n[r + s] = e[s]);
      } else
        i !== o && (n[r + s] = e[s]);
    } else
      n[r + s] = void 0;
  }), I(e).forEach((s) => {
    z(t, s) || (n[r + s] = e[s]);
  }), n;
}
const Lr = { stack: "dbcore", name: "HooksMiddleware", level: 2, create: (t) => ({ ...t, table(e) {
  const n = t.table(e), { primaryKey: r } = n.schema;
  return { ...n, mutate(s) {
    const i = E.trans, { deleting: o, creating: u, updating: a } = i.table(e).hook;
    switch (s.type) {
      case "add":
        if (u.fire === K)
          break;
        return i._promise("readwrite", () => c(s), !0);
      case "put":
        if (u.fire === K && a.fire === K)
          break;
        return i._promise("readwrite", () => c(s), !0);
      case "delete":
        if (o.fire === K)
          break;
        return i._promise("readwrite", () => c(s), !0);
      case "deleteRange":
        if (o.fire === K)
          break;
        return i._promise("readwrite", () => function(l) {
          return h(l.trans, l.range, 1e4);
        }(s), !0);
    }
    return n.mutate(s);
    function c(l) {
      const d = E.trans, p = l.keys || function(m, f) {
        return f.type === "delete" ? f.keys : f.keys || f.values.map(m.extractKey);
      }(r, l);
      if (!p)
        throw new Error("Keys missing");
      return (l = l.type === "add" || l.type === "put" ? { ...l, keys: p } : { ...l }).type !== "delete" && (l.values = [...l.values]), l.keys && (l.keys = [...l.keys]), function(m, f, v) {
        return f.type === "add" ? Promise.resolve([]) : m.getMany({ trans: f.trans, keys: v, cache: "immutable" });
      }(n, l, p).then((m) => {
        const f = p.map((v, y) => {
          const g = m[y], b = { onerror: null, onsuccess: null };
          if (l.type === "delete")
            o.fire.call(b, v, g, d);
          else if (l.type === "add" || g === void 0) {
            const w = u.fire.call(b, v, l.values[y], d);
            v == null && w != null && (v = w, l.keys[y] = v, r.outbound || Y(l.values[y], r.keyPath, v));
          } else {
            const w = ln(g, l.values[y]), C = a.fire.call(b, w, v, g, d);
            if (C) {
              const k = l.values[y];
              Object.keys(C).forEach((_) => {
                z(k, _) ? k[_] = C[_] : Y(k, _, C[_]);
              });
            }
          }
          return b;
        });
        return n.mutate(l).then(({ failures: v, results: y, numFailures: g, lastResult: b }) => {
          for (let w = 0; w < p.length; ++w) {
            const C = y ? y[w] : p[w], k = f[w];
            C == null ? k.onerror && k.onerror(v[w]) : k.onsuccess && k.onsuccess(l.type === "put" && m[w] ? l.values[w] : C);
          }
          return { failures: v, results: y, numFailures: g, lastResult: b };
        }).catch((v) => (f.forEach((y) => y.onerror && y.onerror(v)), Promise.reject(v)));
      });
    }
    function h(l, d, p) {
      return n.query({ trans: l, values: !1, query: { index: r, range: d }, limit: p }).then(({ result: m }) => c({ type: "delete", keys: m, trans: l }).then((f) => f.numFailures > 0 ? Promise.reject(f.failures[0]) : m.length < p ? { failures: [], numFailures: 0, lastResult: void 0 } : h(l, { ...d, lower: m[m.length - 1], lowerOpen: !0 }, p)));
    }
  } };
} }) };
function Jn(t, e, n) {
  try {
    if (!e || e.keys.length < t.length)
      return null;
    const r = [];
    for (let s = 0, i = 0; s < e.keys.length && i < t.length; ++s)
      L(e.keys[s], t[i]) === 0 && (r.push(n ? Ve(e.values[s]) : e.values[s]), ++i);
    return r.length === t.length ? r : null;
  } catch {
    return null;
  }
}
const Ur = { stack: "dbcore", level: -1, create: (t) => ({ table: (e) => {
  const n = t.table(e);
  return { ...n, getMany: (r) => {
    if (!r.cache)
      return n.getMany(r);
    const s = Jn(r.keys, r.trans._cache, r.cache === "clone");
    return s ? S.resolve(s) : n.getMany(r).then((i) => (r.trans._cache = { keys: r.keys, values: r.cache === "clone" ? Ve(i) : i }, i));
  }, mutate: (r) => (r.type !== "add" && (r.trans._cache = null), n.mutate(r)) };
} }) };
function cn(t) {
  return !("from" in t);
}
const Q = function(t, e) {
  if (!this) {
    const n = new Q();
    return t && "d" in t && U(n, t), n;
  }
  U(this, arguments.length ? { d: 1, from: t, to: arguments.length > 1 ? e : t } : { d: 0 });
};
function We(t, e, n) {
  const r = L(e, n);
  if (isNaN(r))
    return;
  if (r > 0)
    throw RangeError();
  if (cn(t))
    return U(t, { from: e, to: n, d: 1 });
  const s = t.l, i = t.r;
  if (L(n, t.from) < 0)
    return s ? We(s, e, n) : t.l = { from: e, to: n, d: 1, l: null, r: null }, _n(t);
  if (L(e, t.to) > 0)
    return i ? We(i, e, n) : t.r = { from: e, to: n, d: 1, l: null, r: null }, _n(t);
  L(e, t.from) < 0 && (t.from = e, t.l = null, t.d = i ? i.d + 1 : 1), L(n, t.to) > 0 && (t.to = n, t.r = null, t.d = t.l ? t.l.d + 1 : 1);
  const o = !t.r;
  s && !t.l && mt(t, s), i && o && mt(t, i);
}
function mt(t, e) {
  cn(e) || function n(r, { from: s, to: i, l: o, r: u }) {
    We(r, s, i), o && n(r, o), u && n(r, u);
  }(t, e);
}
function Wr(t, e) {
  const n = Xt(e);
  let r = n.next();
  if (r.done)
    return !1;
  let s = r.value;
  const i = Xt(t);
  let o = i.next(s.from), u = o.value;
  for (; !r.done && !o.done; ) {
    if (L(u.from, s.to) <= 0 && L(u.to, s.from) >= 0)
      return !0;
    L(s.from, u.from) < 0 ? s = (r = n.next(u.from)).value : u = (o = i.next(s.from)).value;
  }
  return !1;
}
function Xt(t) {
  let e = cn(t) ? null : { s: 0, n: t };
  return { next(n) {
    const r = arguments.length > 0;
    for (; e; )
      switch (e.s) {
        case 0:
          if (e.s = 1, r)
            for (; e.n.l && L(n, e.n.from) < 0; )
              e = { up: e, n: e.n.l, s: 1 };
          else
            for (; e.n.l; )
              e = { up: e, n: e.n.l, s: 1 };
        case 1:
          if (e.s = 2, !r || L(n, e.n.to) <= 0)
            return { value: e.n, done: !1 };
        case 2:
          if (e.n.r) {
            e.s = 3, e = { up: e, n: e.n.r, s: 0 };
            continue;
          }
        case 3:
          e = e.up;
      }
    return { done: !0 };
  } };
}
function _n(t) {
  var e, n;
  const r = (((e = t.r) === null || e === void 0 ? void 0 : e.d) || 0) - (((n = t.l) === null || n === void 0 ? void 0 : n.d) || 0), s = r > 1 ? "r" : r < -1 ? "l" : "";
  if (s) {
    const i = s === "r" ? "l" : "r", o = { ...t }, u = t[s];
    t.from = u.from, t.to = u.to, t[s] = u[s], o[s] = u[i], t[i] = o, o.d = kn(o);
  }
  t.d = kn(t);
}
function kn({ r: t, l: e }) {
  return (t ? e ? Math.max(t.d, e.d) : t.d : e ? e.d : 0) + 1;
}
Ce(Q.prototype, { add(t) {
  return mt(this, t), this;
}, addKey(t) {
  return We(this, t, t), this;
}, addKeys(t) {
  return t.forEach((e) => We(this, e, e)), this;
}, [Ot]() {
  return Xt(this);
} });
const Vr = { stack: "dbcore", level: 0, create: (t) => {
  const e = t.schema.name, n = new Q(t.MIN_KEY, t.MAX_KEY);
  return { ...t, table: (r) => {
    const s = t.table(r), { schema: i } = s, { primaryKey: o } = i, { extractKey: u, outbound: a } = o, c = { ...s, mutate: (d) => {
      const p = d.trans, m = p.mutatedParts || (p.mutatedParts = {}), f = (k) => {
        const _ = `idb://${e}/${r}/${k}`;
        return m[_] || (m[_] = new Q());
      }, v = f(""), y = f(":dels"), { type: g } = d;
      let [b, w] = d.type === "deleteRange" ? [d.range] : d.type === "delete" ? [d.keys] : d.values.length < 50 ? [[], d.values] : [];
      const C = d.trans._cache;
      return s.mutate(d).then((k) => {
        if (M(b)) {
          g !== "delete" && (b = k.results), v.addKeys(b);
          const _ = Jn(b, C);
          _ || g === "add" || y.addKeys(b), (_ || w) && function(O, x, R, A) {
            function q(B) {
              const j = O(B.name || "");
              function ge(W) {
                return W != null ? B.extractKey(W) : null;
              }
              const ye = (W) => B.multiEntry && M(W) ? W.forEach((le) => j.addKey(le)) : j.addKey(W);
              (R || A).forEach((W, le) => {
                const Oe = R && ge(R[le]), vt = A && ge(A[le]);
                L(Oe, vt) !== 0 && (Oe != null && ye(Oe), vt != null && ye(vt));
              });
            }
            x.indexes.forEach(q);
          }(f, i, _, w);
        } else if (b) {
          const _ = { from: b.lower, to: b.upper };
          y.add(_), v.add(_);
        } else
          v.add(n), y.add(n), i.indexes.forEach((_) => f(_.name).add(n));
        return k;
      });
    } }, h = ({ query: { index: d, range: p } }) => {
      var m, f;
      return [d, new Q((m = p.lower) !== null && m !== void 0 ? m : t.MIN_KEY, (f = p.upper) !== null && f !== void 0 ? f : t.MAX_KEY)];
    }, l = { get: (d) => [o, new Q(d.key)], getMany: (d) => [o, new Q().addKeys(d.keys)], count: h, query: h, openCursor: h };
    return I(l).forEach((d) => {
      c[d] = function(p) {
        const { subscr: m } = E;
        if (m) {
          const f = (w) => {
            const C = `idb://${e}/${r}/${w}`;
            return m[C] || (m[C] = new Q());
          }, v = f(""), y = f(":dels"), [g, b] = l[d](p);
          if (f(g.name || "").add(b), !g.isPrimaryKey) {
            if (d !== "count") {
              const w = d === "query" && a && p.values && s.query({ ...p, values: !1 });
              return s[d].apply(this, arguments).then((C) => {
                if (d === "query") {
                  if (a && p.values)
                    return w.then(({ result: _ }) => (v.addKeys(_), C));
                  const k = p.values ? C.result.map(u) : C.result;
                  p.values ? v.addKeys(k) : y.addKeys(k);
                } else if (d === "openCursor") {
                  const k = C, _ = p.values;
                  return k && Object.create(k, { key: { get: () => (y.addKey(k.primaryKey), k.key) }, primaryKey: { get() {
                    const O = k.primaryKey;
                    return y.addKey(O), O;
                  } }, value: { get: () => (_ && v.addKey(k.primaryKey), k.value) } });
                }
                return C;
              });
            }
            y.add(n);
          }
        }
        return s[d].apply(this, arguments);
      };
    }), c;
  } };
} };
class Se {
  constructor(e, n) {
    this._middlewares = {}, this.verno = 0;
    const r = Se.dependencies;
    this._options = n = { addons: Se.addons, autoOpen: !0, indexedDB: r.indexedDB, IDBKeyRange: r.IDBKeyRange, ...n }, this._deps = { indexedDB: n.indexedDB, IDBKeyRange: n.IDBKeyRange };
    const { addons: s } = n;
    this._dbSchema = {}, this._versions = [], this._storeNames = [], this._allTables = {}, this.idbdb = null, this._novip = this;
    const i = { dbOpenError: null, isBeingOpened: !1, onReadyBeingFired: null, openComplete: !1, dbReadyResolve: K, dbReadyPromise: null, cancelOpen: K, openCanceller: null, autoSchema: !0, PR1398_maxLoop: 3 };
    var o;
    i.dbReadyPromise = new S((u) => {
      i.dbReadyResolve = u;
    }), i.openCanceller = new S((u, a) => {
      i.cancelOpen = a;
    }), this._state = i, this.name = e, this.on = Ie(this, "populate", "blocked", "versionchange", "close", { ready: [nn, K] }), this.on.ready.subscribe = Sn(this.on.ready.subscribe, (u) => (a, c) => {
      Se.vip(() => {
        const h = this._state;
        if (h.openComplete)
          h.dbOpenError || S.resolve().then(a), c && u(a);
        else if (h.onReadyBeingFired)
          h.onReadyBeingFired.push(a), c && u(a);
        else {
          u(a);
          const l = this;
          c || u(function d() {
            l.on.ready.unsubscribe(a), l.on.ready.unsubscribe(d);
          });
        }
      });
    }), this.Collection = (o = this, Ae(Tr.prototype, function(u, a) {
      this.db = o;
      let c = Vn, h = null;
      if (a)
        try {
          c = a();
        } catch (m) {
          h = m;
        }
      const l = u._ctx, d = l.table, p = d.hook.reading.fire;
      this._ctx = { table: d, index: l.index, isPrimKey: !l.index || d.schema.primKey.keyPath && l.index === d.schema.primKey.name, range: c, keysOnly: !1, dir: "next", unique: "", algorithm: null, filter: null, replayFilter: null, justLimit: !0, isMatch: null, offset: 0, limit: 1 / 0, error: h, or: l.or, valueMapper: p !== Fe ? p : null };
    })), this.Table = function(u) {
      return Ae(Pr.prototype, function(a, c, h) {
        this.db = u, this._tx = h, this.name = a, this.schema = c, this.hook = u._allTables[a] ? u._allTables[a].hook : Ie(null, { creating: [mr, K], reading: [pr, Fe], updating: [yr, K], deleting: [gr, K] });
      });
    }(this), this.Transaction = function(u) {
      return Ae($r.prototype, function(a, c, h, l, d) {
        this.db = u, this.mode = a, this.storeNames = c, this.schema = h, this.chromeTransactionDurability = l, this.idbtrans = null, this.on = Ie(this, "complete", "error", "abort"), this.parent = d || null, this.active = !0, this._reculock = 0, this._blockedFuncs = [], this._resolve = null, this._reject = null, this._waitingFor = null, this._waitingQueue = null, this._spinCount = 0, this._completion = new S((p, m) => {
          this._resolve = p, this._reject = m;
        }), this._completion.then(() => {
          this.active = !1, this.on.complete.fire();
        }, (p) => {
          var m = this.active;
          return this.active = !1, this.on.error.fire(p), this.parent ? this.parent._reject(p) : m && this.idbtrans && this.idbtrans.abort(), D(p);
        });
      });
    }(this), this.Version = function(u) {
      return Ae(Dr.prototype, function(a) {
        this.db = u, this._cfg = { version: a, storesSource: null, dbschema: {}, tables: {}, contentUpgrade: null };
      });
    }(this), this.WhereClause = function(u) {
      return Ae(Yn.prototype, function(a, c, h) {
        this.db = u, this._ctx = { table: a, index: c === ":id" ? null : c, or: h };
        const l = u._deps.indexedDB;
        if (!l)
          throw new P.MissingAPI();
        this._cmp = this._ascending = l.cmp.bind(l), this._descending = (d, p) => l.cmp(p, d), this._max = (d, p) => l.cmp(d, p) > 0 ? d : p, this._min = (d, p) => l.cmp(d, p) < 0 ? d : p, this._IDBKeyRange = u._deps.IDBKeyRange;
      });
    }(this), this.on("versionchange", (u) => {
      u.newVersion > 0 ? console.warn(`Another connection wants to upgrade database '${this.name}'. Closing db now to resume the upgrade.`) : console.warn(`Another connection wants to delete database '${this.name}'. Closing db now to resume the delete request.`), this.close();
    }), this.on("blocked", (u) => {
      !u.newVersion || u.newVersion < u.oldVersion ? console.warn(`Dexie.delete('${this.name}') was blocked`) : console.warn(`Upgrade '${this.name}' blocked by other connection holding version ${u.oldVersion / 10}`);
    }), this._maxKey = Ue(n.IDBKeyRange), this._createTransaction = (u, a, c, h) => new this.Transaction(u, a, c, this._options.chromeTransactionDurability, h), this._fireOnBlocked = (u) => {
      this.on("blocked").fire(u), je.filter((a) => a.name === this.name && a !== this && !a._state.vcFired).map((a) => a.on("versionchange").fire(u));
    }, this.use(qr), this.use(Lr), this.use(Vr), this.use(Ur), this.vip = Object.create(this, { _vip: { value: !0 } }), s.forEach((u) => u(this));
  }
  version(e) {
    if (isNaN(e) || e < 0.1)
      throw new P.Type("Given version is not a positive number");
    if (e = Math.round(10 * e) / 10, this.idbdb || this._state.isBeingOpened)
      throw new P.Schema("Cannot add version when database is open");
    this.verno = Math.max(this.verno, e);
    const n = this._versions;
    var r = n.filter((s) => s._cfg.version === e)[0];
    return r || (r = new this.Version(e), n.push(r), n.sort(jr), r.stores({}), this._state.autoSchema = !1, r);
  }
  _whenReady(e) {
    return this.idbdb && (this._state.openComplete || E.letThrough || this._vip) ? e() : new S((n, r) => {
      if (this._state.openComplete)
        return r(new P.DatabaseClosed(this._state.dbOpenError));
      if (!this._state.isBeingOpened) {
        if (!this._options.autoOpen)
          return void r(new P.DatabaseClosed());
        this.open().catch(K);
      }
      this._state.dbReadyPromise.then(n, r);
    }).then(e);
  }
  use({ stack: e, create: n, level: r, name: s }) {
    s && this.unuse({ stack: e, name: s });
    const i = this._middlewares[e] || (this._middlewares[e] = []);
    return i.push({ stack: e, create: n, level: r ?? 10, name: s }), i.sort((o, u) => o.level - u.level), this;
  }
  unuse({ stack: e, name: n, create: r }) {
    return e && this._middlewares[e] && (this._middlewares[e] = this._middlewares[e].filter((s) => r ? s.create !== r : !!n && s.name !== n)), this;
  }
  open() {
    return Fr(this);
  }
  _close() {
    const e = this._state, n = je.indexOf(this);
    if (n >= 0 && je.splice(n, 1), this.idbdb) {
      try {
        this.idbdb.close();
      } catch {
      }
      this._novip.idbdb = null;
    }
    e.dbReadyPromise = new S((r) => {
      e.dbReadyResolve = r;
    }), e.openCanceller = new S((r, s) => {
      e.cancelOpen = s;
    });
  }
  close() {
    this._close();
    const e = this._state;
    this._options.autoOpen = !1, e.dbOpenError = new P.DatabaseClosed(), e.isBeingOpened && e.cancelOpen(e.dbOpenError);
  }
  delete() {
    const e = arguments.length > 0, n = this._state;
    return new S((r, s) => {
      const i = () => {
        this.close();
        var o = this._deps.indexedDB.deleteDatabase(this.name);
        o.onsuccess = N(() => {
          (function({ indexedDB: u, IDBKeyRange: a }, c) {
            !un(u) && c !== yt && an(u, a).delete(c).catch(K);
          })(this._deps, this.name), r();
        }), o.onerror = H(s), o.onblocked = this._fireOnBlocked;
      };
      if (e)
        throw new P.InvalidArgument("Arguments not allowed in db.delete()");
      n.isBeingOpened ? n.dbReadyPromise.then(i) : i();
    });
  }
  backendDB() {
    return this.idbdb;
  }
  isOpen() {
    return this.idbdb !== null;
  }
  hasBeenClosed() {
    const e = this._state.dbOpenError;
    return e && e.name === "DatabaseClosed";
  }
  hasFailed() {
    return this._state.dbOpenError !== null;
  }
  dynamicallyOpened() {
    return this._state.autoSchema;
  }
  get tables() {
    return I(this._allTables).map((e) => this._allTables[e]);
  }
  transaction() {
    const e = Mr.apply(this, arguments);
    return this._transaction.apply(this, e);
  }
  _transaction(e, n, r) {
    let s = E.trans;
    s && s.db === this && e.indexOf("!") === -1 || (s = null);
    const i = e.indexOf("?") !== -1;
    let o, u;
    e = e.replace("!", "").replace("?", "");
    try {
      if (u = n.map((c) => {
        var h = c instanceof this.Table ? c.name : c;
        if (typeof h != "string")
          throw new TypeError("Invalid table argument to Dexie.transaction(). Only Table or String are allowed");
        return h;
      }), e == "r" || e === _t)
        o = _t;
      else {
        if (e != "rw" && e != kt)
          throw new P.InvalidArgument("Invalid transaction mode: " + e);
        o = kt;
      }
      if (s) {
        if (s.mode === _t && o === kt) {
          if (!i)
            throw new P.SubTransaction("Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY");
          s = null;
        }
        s && u.forEach((c) => {
          if (s && s.storeNames.indexOf(c) === -1) {
            if (!i)
              throw new P.SubTransaction("Table " + c + " not included in parent transaction.");
            s = null;
          }
        }), i && s && !s.active && (s = null);
      }
    } catch (c) {
      return s ? s._promise(null, (h, l) => {
        l(c);
      }) : D(c);
    }
    const a = Qn.bind(null, this, o, u, s, r);
    return s ? s._promise(o, a, "lock") : E.trans ? Te(E.transless, () => this._whenReady(a)) : this._whenReady(a);
  }
  table(e) {
    if (!z(this._allTables, e))
      throw new P.InvalidTable(`Table ${e} does not exist`);
    return this._allTables[e];
  }
}
const zr = typeof Symbol < "u" && "observable" in Symbol ? Symbol.observable : "@@observable";
class Yr {
  constructor(e) {
    this._subscribe = e;
  }
  subscribe(e, n, r) {
    return this._subscribe(e && typeof e != "function" ? e : { next: e, error: n, complete: r });
  }
  [zr]() {
    return this;
  }
}
function Zn(t, e) {
  return I(e).forEach((n) => {
    mt(t[n] || (t[n] = new Q()), e[n]);
  }), t;
}
function Hr(t) {
  let e, n = !1;
  const r = new Yr((s) => {
    const i = Zt(t);
    let o = !1, u = {}, a = {};
    const c = { get closed() {
      return o;
    }, unsubscribe: () => {
      o = !0, ue.storagemutated.unsubscribe(p);
    } };
    s.start && s.start(c);
    let h = !1, l = !1;
    function d() {
      return I(a).some((f) => u[f] && Wr(u[f], a[f]));
    }
    const p = (f) => {
      Zn(u, f), d() && m();
    }, m = () => {
      if (h || o)
        return;
      u = {};
      const f = {}, v = function(y) {
        i && Pe();
        const g = () => oe(t, { subscr: y, trans: null }), b = E.trans ? Te(E.transless, g) : g();
        return i && b.then(ne, ne), b;
      }(f);
      l || (ue(Le, p), l = !0), h = !0, Promise.resolve(v).then((y) => {
        n = !0, e = y, h = !1, o || (d() ? m() : (u = {}, a = f, s.next && s.next(y)));
      }, (y) => {
        h = !1, n = !1, s.error && s.error(y), c.unsubscribe();
      });
    };
    return m(), c;
  });
  return r.hasValue = () => n, r.getValue = () => e, r;
}
let Qt;
try {
  Qt = { indexedDB: $.indexedDB || $.mozIndexedDB || $.webkitIndexedDB || $.msIndexedDB, IDBKeyRange: $.IDBKeyRange || $.webkitIDBKeyRange };
} catch {
  Qt = { indexedDB: null, IDBKeyRange: null };
}
const ce = Se;
function at(t) {
  let e = Z;
  try {
    Z = !0, ue.storagemutated.fire(t);
  } finally {
    Z = e;
  }
}
Ce(ce, { ...tt, delete: (t) => new ce(t, { addons: [] }).delete(), exists: (t) => new ce(t, { addons: [] }).open().then((e) => (e.close(), !0)).catch("NoSuchDatabaseError", () => !1), getDatabaseNames(t) {
  try {
    return function({ indexedDB: e, IDBKeyRange: n }) {
      return un(e) ? Promise.resolve(e.databases()).then((r) => r.map((s) => s.name).filter((s) => s !== yt)) : an(e, n).toCollection().primaryKeys();
    }(ce.dependencies).then(t);
  } catch {
    return D(new P.MissingAPI());
  }
}, defineClass: () => function(t) {
  U(this, t);
}, ignoreTransaction: (t) => E.trans ? Te(E.transless, t) : t(), vip: Ht, async: function(t) {
  return function() {
    try {
      var e = Gt(t.apply(this, arguments));
      return e && typeof e.then == "function" ? e : S.resolve(e);
    } catch (n) {
      return D(n);
    }
  };
}, spawn: function(t, e, n) {
  try {
    var r = Gt(t.apply(n, e || []));
    return r && typeof r.then == "function" ? r : S.resolve(r);
  } catch (s) {
    return D(s);
  }
}, currentTransaction: { get: () => E.trans || null }, waitFor: function(t, e) {
  const n = S.resolve(typeof t == "function" ? ce.ignoreTransaction(t) : t).timeout(e || 6e4);
  return E.trans ? E.trans.waitFor(n) : n;
}, Promise: S, debug: { get: () => G, set: (t) => {
  An(t, t === "dexie" ? () => !0 : Wn);
} }, derive: _e, extend: U, props: Ce, override: Sn, Events: Ie, on: ue, liveQuery: Hr, extendObservabilitySet: Zn, getByKeyPath: te, setByKeyPath: Y, delByKeyPath: function(t, e) {
  typeof e == "string" ? Y(t, e, void 0) : "length" in e && [].map.call(e, function(n) {
    Y(t, n, void 0);
  });
}, shallowClone: Pn, deepClone: Ve, getObjectDiff: ln, cmp: L, asap: Cn, minKey: Mt, addons: [], connections: je, errnames: tn, dependencies: Qt, semVer: mn, version: mn.split(".").map((t) => parseInt(t)).reduce((t, e, n) => t + e / Math.pow(10, 2 * n)) }), ce.maxKey = Ue(ce.dependencies.IDBKeyRange), typeof dispatchEvent < "u" && typeof addEventListener < "u" && (ue(Le, (t) => {
  if (!Z) {
    let e;
    gt ? (e = document.createEvent("CustomEvent"), e.initCustomEvent(ie, !0, !0, t)) : e = new CustomEvent(ie, { detail: t }), Z = !0, dispatchEvent(e), Z = !1;
  }
}), addEventListener(ie, ({ detail: t }) => {
  Z || at(t);
}));
let Z = !1;
if (typeof BroadcastChannel < "u") {
  const t = new BroadcastChannel(ie);
  typeof t.unref == "function" && t.unref(), ue(Le, (e) => {
    Z || t.postMessage(e);
  }), t.onmessage = (e) => {
    e.data && at(e.data);
  };
} else if (typeof self < "u" && typeof navigator < "u") {
  ue(Le, (e) => {
    try {
      Z || (typeof localStorage < "u" && localStorage.setItem(ie, JSON.stringify({ trig: Math.random(), changedParts: e })), typeof self.clients == "object" && [...self.clients.matchAll({ includeUncontrolled: !0 })].forEach((n) => n.postMessage({ type: ie, changedParts: e })));
    } catch {
    }
  }), typeof addEventListener < "u" && addEventListener("storage", (e) => {
    if (e.key === ie) {
      const n = JSON.parse(e.newValue);
      n && at(n.changedParts);
    }
  });
  const t = self.document && navigator.serviceWorker;
  t && t.addEventListener("message", function({ data: e }) {
    e && e.type === ie && at(e.changedParts);
  });
}
S.rejectionMapper = function(t, e) {
  if (!t || t instanceof ke || t instanceof TypeError || t instanceof SyntaxError || !t.name || !hn[t.name])
    return t;
  var n = new hn[t.name](e || t.message, t);
  return "stack" in t && ee(n, "stack", { get: function() {
    return this.inner.stack;
  } }), n;
}, An(G, Wn);
export {
  Xr as N,
  Qr as X,
  rr as n
};
